import { statusLegadoClass } from '../../shared/status-legado';
import { codVendCompradorDoUsuario } from '../../shared/comprador-por-usuario';
import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
import * as XLSX from 'xlsx';
// @ts-ignore
import { Component, OnInit, Input, Output, EventEmitter, signal, HostListener, OnDestroy } from '@angular/core';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { FormsModule } from '@angular/forms';
import { firstValueFrom, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, timeout } from 'rxjs/operators';
import { SankhyaGatewayService, DemonstrativoCotacao } from '../../services/sankhya-gateway.service';
import { EmpresaStateService } from '../../services/empresa-state.service';
import { ProdutoService } from '../../services/produto.service';
import { ordenarSugestoesParceiro } from '../../shared/ordenar-sugestoes-parceiro';

// ── Interfaces ─────────────────────────────────────────────────────────────

interface FornecedorSugestao {
  codparc:      string | number;
  nomeparc:     string;
  docparc?:     string;
  inscEstadual?: string;
  cidade?:      string;
  uf?:          string;
}

interface VendedorOpcao {
  codVend: string | number;
  apelido: string;
}

interface OpcaoCampo {
  valor: string;
  opcao: string;
}

interface ItemCompra {
  id:              number;
  codprod:         string;
  codprodOriginal?: string;
  codprodInterno?: number;
  codlocalpadrao?: number;
  localSel?: number;
  /** 'RECENTE' (padrão) = entrada mais recente; 'FIFO' = entrada mais antiga com saldo. */
  localOrdem?: 'RECENTE' | 'FIFO';
  locaisOpcoes?: { codLocal: number; descrLocal: string; estoque: number; dtEntrada: string }[];
  localAerosys?: string;
  descricao:       string;
  unidade:         string;
  quantidade:      number;
  precoUsd:        number;
  precoUnitario:   number;
  desconto:        number;
  vlrDesc:         number;
  vlrAcrescDesc:   number;
  total:           number;
  totalUsd:        number;
  controlaCore:    boolean;  // AD_CONTROLACORE = 'S' em TGFPRO
  vlrCore:         number;   // AD_VLRCORE em TGFPRO — Core Unit U$ (já embutido em precoUsd/precoUnitario quando ativo)
  coreUnitBrl:     number;   // vlrCore × cotação — Core Unit R$
  totalCoreBrl:    number;   // qtd × coreUnitBrl — informativo
  estoque:         number;
  precoUsdStr?:    string;
  buscando?:       boolean;

  // ── Painel "Peças com Venda nos últimos X meses" (Aerosys + Sankhya) ──
  cd?:                 string;
  custoAnalitico?:     number | null;
  pontoPedido?:        number | null;
  estoqueEua?:         number | null;
  qtdeVendas?:         number | null;
  qtdeVendasAnoAnt?:   number | null;
  qtdePedidoOutros?:   number | null;
  pedidoOutros?:       string;
  qtdePrecompraAbBk?:  number | null;
  dataPrecompraAbBk?:  string;

  // ── Item importado de Pré-Compra (Funções > Importar Pré-Compras) ──
  origemItem?:     'SANKHYA' | 'AEROSYS';
  headerIdOrigem?: number;
  seqOrigem?:      number;
  custoPedidoBrl?: number;
  cotacaoPedido?:  number;
  pedidoNacional?: boolean;
  /** PCI_ID (item da pré-compra no Aerosys) e PCP_ID (pré-compra no Aerosys). */
  pciId?:          number;
  pcpId?:          number;
}

/** Uma linha lida do Excel para importação de itens. */
interface ExcelImportRow {
  pn:             string;
  quantidade:     number;
  status:         'pendente' | 'encontrado' | 'nao_encontrado';
  descricao?:     string;
  codprodInterno?: number;
  codlocalpadrao?: number;
  localSel?: number;
  /** 'RECENTE' (padrão) = entrada mais recente; 'FIFO' = entrada mais antiga com saldo. */
  localOrdem?: 'RECENTE' | 'FIFO';
  locaisOpcoes?: { codLocal: number; descrLocal: string; estoque: number; dtEntrada: string }[];
  localAerosys?: string;
  prodData?:      any;
  proximosData?:  any[];
}

// @ts-ignore
@Component({
  selector: 'app-compra-form',
  standalone: true,
  imports: [LoadingIndicatorComponent, CommonModule, FormsModule],
  templateUrl: './compra-form.component.html',
  styleUrls: [
    '../../shared/styles/pedido-form-shared.css',
    '../../shared/styles/busca-pecas-shared.css',
    './compra-form.component.css',
  ],
})
export class CompraFormComponent implements OnInit, OnDestroy {
  readonly statusLegadoClass = statusLegadoClass;

  // ── Modo edição ─────────────────────────────────────────────
  @Input()  nunotaEditar: number | null = null;
  @Output() voltarLista  = new EventEmitter<void>();

  // ── Confirmação de saída (mesmo padrão do Pedido de Compra/Venda) ──
  confirmacaoSairAberta = false;
  private _aoConfirmarSaida: (() => void) | null = null;

  onVoltarClick(): void {
    this.confirmacaoSairAberta = true;
  }

  /** Chamado pelo gateway ao clicar em outro item do menu; retorna false (aguarda o modal). */
  solicitarSaida(aoConfirmar: () => void): boolean {
    this._aoConfirmarSaida = aoConfirmar;
    this.confirmacaoSairAberta = true;
    return false;
  }

  confirmarSair(): void {
    this.confirmacaoSairAberta = false;
    if (this._aoConfirmarSaida) {
      const cb = this._aoConfirmarSaida;
      this._aoConfirmarSaida = null;
      cb();
    } else {
      this.voltarLista.emit();
    }
  }

  cancelarSair(): void {
    this.confirmacaoSairAberta = false;
    this._aoConfirmarSaida = null;
  }

  modoEdicao       = false;
  nunotaAtual: number | null = null;
  carregandoEdicao = false;

  /** A pedido do usuário (2026-08-27): esconde, por enquanto, as colunas
   *  financeiras (Descrição/Preço U$/Preço R$/Desc%/Total R$) e a linha de
   *  TOTAL DO PEDIDO na grade de Itens da Compra -- não é usado
   *  nesse fluxo no momento. Fica atrás de uma flag (em vez de apagar) pra
   *  ser fácil trazer de volta se precisar. */
  exibirColunasPreco = true;

  // ── Estado geral ────────────────────────────────────────────
  salvando     = signal(false);
  alerta: { mensagem: string; tipo: 'sucesso' | 'erro' | 'aviso' } | null = null;

  // ── Tabs ────────────────────────────────────────────────────
  abaAtiva: 'dados' | 'itens' = 'dados';

  /** Avisa o gateway quando a aba Itens abre/fecha (ele recolhe o menu lateral). */
  @Output() abaItensChange = new EventEmitter<boolean>();

  mudarAba(aba: 'dados' | 'itens'): void {
    this.abaAtiva = aba;
    this.abaItensChange.emit(aba === 'itens');
    if (aba === 'itens') {
      setTimeout(() => {
        const pns = Array.from(document.querySelectorAll<HTMLInputElement>('.pcf-cell-pn'));
        (pns.find(i => !i.value && !i.disabled) ?? pns[0])?.focus();
      }, 80);
    }
  }

  // ── Helpers expostos ao template ────────────────────────────
  readonly String = String;

  // ── TOP fixo ────────────────────────────────────────────────
  // TEMPORÁRIO (2026-09-08, a pedido do usuário): ainda não existe uma TOP
  // dedicada de "Compra" no Sankhya, então esta tela usa a MESMA TOP 1301
  // da Pré-Compra por enquanto, só pra deixar a tela pronta -- os dois
  // fluxos vão gerar NUNOTA sob o mesmo CODTIPOPER até o usuário criar a TOP
  // definitiva e eu trocar esse valor aqui. TOP 1300 é a TOP do Pedido de
  // Compra (tela separada, pedido-compra-form) -- não usar aqui.
  // Agora depende do TIPO (GPL_TIPO): IMPORTAÇÃO (internacional) = 1408, NACIONAL = 1401.
  get COD_TIP_OPER(): number {
    return this.tipoGpl === 'NACIONAL' ? 1401 : 1408;
  }
  /** Nome real da TOP (TGFTOP.DESCROPER), carregado em ngOnInit -- evita
   *  texto fixo no front que fica desatualizado se a TOP for renomeada ou
   *  reatribuída. 'Compra' é só o fallback enquanto carrega/se falhar (hoje
   *  vai mostrar "Pré-Compra", que é o nome real da TOP 1301 compartilhada). */
  descricaoTop = 'Compra';

  // ── Cabeçalho ───────────────────────────────────────────────
  dataEmissao   = '';
  dtPrevent     = '';
  observacao    = '';          // TGFCAB.OBSERVACAO ("Observação do Comprador")
  observacaoInterna = '';      // TGFCAB.AD_OBSINT ("Observação Interna")
  numPedido2    = '';
  /** GPL_STATUS (espelho do status no Aerosys) -- só existe depois de salvo,
   *  carregado em carregarParaEdicao. Somente leitura na tela. */
  gplStatusAtual = '';

  // ── Campos de referência opcionais (AD_*) -- espelhados no Aerosys ────
  // (COMPRA.NUM_TITULO/PO/NUM_FORN/NUM_COT/NUM_ENTREGA/NUM_RASTREAMENTO).
  // "numOrdem" é o único com nome diferente no Aerosys (cai em numForn/
  // NUM_FORN, rotulado "Nº Ord" na tela nativa).
  numTitulo       = '';
  numPo           = '';
  numOrdem        = '';
  numCotacao      = '';
  numEntrega      = '';
  numRastreamento = '';

  // ── Fornecedor (CODPARC) ────────────────────────────────────
  fornecedorBusca           = '';
  fornecedorSelecionado: FornecedorSugestao | null = null;
  fornecedorSugestoes: FornecedorSugestao[] = [];
  fornecedorCarregando      = false;
  mostrarDropdownFornecedor = false;
  private _fornecedorTimer: any = null;
  private _fornecedorAnterior: FornecedorSugestao | null = null;

  // Modal de fornecedor (lupa)
  fornecedorModalAberta  = false;
  filtroFornecedorModal  = '';
  fornecedorModalLista: FornecedorSugestao[] = [];
  fornecedorModalCarregando = false;
  private _fornecedorModalTimer: any = null;

  // ── Títulos flutuantes do Fornecedor (canvas) ────────────────
  titulosFornecedorPosicionados: { label: string; left: number }[] = [];
  private readonly FORNEC_INPUT_TEXT_START_PX = 34;
  private readonly FORNEC_INPUT_FONT = '400 13px "Segoe UI", Roboto, Arial, sans-serif';
  private _fornecCanvasCtx: CanvasRenderingContext2D | null = null;

  // ── Cliente a ser Entregue (CODPARC destino -- mesmo campo/conceito da
  //    "Pessoa de Entrega" da aba Transporte no Pedido de Venda; aqui salvo
  //    em cabecalho.codParcDest) ───────────────────────────────
  clienteEntregaBusca           = '';
  clienteEntregaSelecionado: FornecedorSugestao | null = null;
  clienteEntregaSugestoes: FornecedorSugestao[] = [];
  clienteEntregaCarregando      = false;
  mostrarDropdownClienteEntrega = false;
  private _clienteEntregaTimer: any = null;
  private _clienteEntregaAnterior: FornecedorSugestao | null = null;

  // Títulos flutuantes do Cliente a ser Entregue (canvas)
  titulosClienteEntregaPosicionados: { label: string; left: number }[] = [];
  private _clienteEntregaCanvasCtx: CanvasRenderingContext2D | null = null;

  // ── Comprador (CODVEND) ─────────────────────────────────────
  compradores: VendedorOpcao[] = [];
  compradorSelecionado: string | number | null = null;
  compradorModalAberta   = false;
  filtroComprador        = '';

  // ── Prioridade (GPL_PRIORIDADE) ──────────────────────────────
  prioridadeSelecionada = 'NORMAL';
  readonly opcoesPrioridade = ['AOG', 'MESA', 'URGENTE', 'NORMAL'];

  /** GPL_TIPO (TGFCAB) -- NACIONAL ou IMPORTAÇÃO. Padrão IMPORTAÇÃO, que é a
   *  realidade da maioria das compras da empresa. */
  tipoGpl = 'IMPORTACAO';
  tipoGplOpcoes: OpcaoCampo[] = [];

  // ── Categoria (TGFCAB.AD_CATEGORIA) -- mesmo domínio/campo usado no
  //    Pedido de Venda (Receita/Transferência). Aqui não há a troca
  //    automática de TOP que existe na Venda (onAdCategoriaChange) -- só
  //    o valor é exibido/salvo. Padrão DESPESA em modo criação -- faz mais
  //    sentido pra um documento de compra do que RECEITA (usado na Venda).
  //    Em edição, o valor salvo no banco prevalece (ver carregarParaEdicao). ────────
  adCategoria = '';
  adCategoriaOpcoes: OpcaoCampo[] = [];

  get compradoresFiltrados(): VendedorOpcao[] {
    const f = this.filtroComprador.trim().toUpperCase();
    return f ? this.compradores.filter(v => (v.apelido || '').toUpperCase().includes(f)) : this.compradores;
  }

  descricaoComprador(codigo: string | number | null): string {
    const c = String(codigo ?? '').trim();
    return this.compradores.find(v => String(v.codVend) === c)?.apelido ?? '';
  }

  valorExibidoComprador(codigo: string | number | null): string {
    const c    = String(codigo ?? '').trim();
    const desc = this.descricaoComprador(c);
    return desc ? `${c} - ${desc}` : c;
  }

  onInputComprador(event: Event): void {
    const input = event.target as HTMLInputElement;
    const val   = input.value;
    const cur   = input.selectionStart ?? val.length;
    const idx   = val.indexOf(' - ');
    const cod   = idx >= 0 ? val.substring(0, idx) : val;
    this.compradorSelecionado = cod;
    const novo  = this.valorExibidoComprador(cod);
    setTimeout(() => {
      input.value = novo;
      const pos   = Math.min(cur, cod.length);
      input.setSelectionRange(pos, pos);
    });
  }

  // ── Tipo Negociação (CODTIPVENDA) ───────────────────────────
  tiposNegociacao: { codTipVenda: string | number; descricao: string }[] = [
    { codTipVenda: '1', descricao: 'A VISTA DINHEIRO' },
  ];
  tipoNegociacaoSelecionado: string | number = '1';
  tipoNegociacaoModalAberta  = false;
  filtroTipoNegociacao       = '';
  tiposNegociacaoCarregando  = false;

  get tiposNegociacaoFiltrados() {
    const f = this.filtroTipoNegociacao.trim().toUpperCase();
    return f
      ? this.tiposNegociacao.filter(t => (t.descricao || '').toUpperCase().includes(f))
      : this.tiposNegociacao;
  }

  descricaoTipoNegociacao(cod: string | number): string {
    return this.tiposNegociacao.find(t => String(t.codTipVenda) === String(cod))?.descricao ?? '';
  }

  valorExibidoTipoNegociacao(cod: string | number): string {
    const desc = this.descricaoTipoNegociacao(cod);
    return desc ? `${cod} - ${desc}` : String(cod);
  }

  // ── Natureza (CODNAT) ────────────────────────────────────────
  naturezas: { codNat: string | number; descricao: string }[] = [
    { codNat: '0', descricao: 'Nenhuma' },
  ];
  // Default 3010101 - PRODUTOS DE REVENDA (pedido do usuário, pra agilizar
  // o preenchimento -- ainda pode ser trocado manualmente).
  naturezaSelecionada: string | number = '3010101';
  naturezaModalAberta  = false;
  filtroNatureza       = '';
  naturezasCarregando  = false;

  get naturezasFiltradas() {
    const f = this.filtroNatureza.trim().toUpperCase();
    return f
      ? this.naturezas.filter(n => (n.descricao || '').toUpperCase().includes(f) || String(n.codNat).includes(f))
      : this.naturezas;
  }

  descricaoNatureza(cod: string | number): string {
    return this.naturezas.find(n => String(n.codNat) === String(cod))?.descricao ?? '';
  }

  valorExibidoNatureza(cod: string | number): string {
    const desc = this.descricaoNatureza(cod);
    return desc ? `${cod} - ${desc}` : String(cod ?? '');
  }

  onInputNatureza(event: Event): void {
    const input = event.target as HTMLInputElement;
    const val   = input.value;
    const cur   = input.selectionStart ?? val.length;
    const idx   = val.indexOf(' - ');
    const cod   = idx >= 0 ? val.substring(0, idx) : val;
    this.naturezaSelecionada = cod;
    const novo = this.valorExibidoNatureza(cod);
    setTimeout(() => {
      input.value = novo;
      const pos = Math.min(cur, cod.length);
      input.setSelectionRange(pos, pos);
    });
  }

  abrirBuscaNatureza(): void {
    this.filtroNatureza  = '';
    this.naturezaModalAberta = true;
    this._carregarNaturezas();
  }
  fecharBuscaNatureza(): void { this.naturezaModalAberta = false; }
  selecionarNatureza(n: { codNat: string | number; descricao: string }): void {
    this.naturezaSelecionada = n.codNat;
    this.naturezaModalAberta = false;
  }
  limparNatureza(): void { this.naturezaSelecionada = '0'; }

  onInputTipoNegociacao(event: Event): void {
    const input = event.target as HTMLInputElement;
    const val   = input.value;
    const cur   = input.selectionStart ?? val.length;
    const idx   = val.indexOf(' - ');
    const cod   = idx >= 0 ? val.substring(0, idx) : val;
    this.tipoNegociacaoSelecionado = cod;
    const novo = this.valorExibidoTipoNegociacao(cod);
    setTimeout(() => {
      input.value = novo;
      const pos = Math.min(cur, cod.length);
      input.setSelectionRange(pos, pos);
    });
  }

  // ── Centro de Resultado (CODCENCUS) ─────────────────────────
  centrosResultado: { codCen: string | number; descricao: string }[] = [
    { codCen: '0', descricao: 'Nenhum' },
  ];
  // Default 201000 - COMPRAS (pedido do usuário).
  centroResultadoSelecionado: string | number = '201000';
  centroResultadoModalAberta  = false;
  filtroCentroResultado       = '';
  centrosResultadoCarregando  = false;

  get centrosResultadoFiltrados() {
    const f = this.filtroCentroResultado.trim().toUpperCase();
    return f
      ? this.centrosResultado.filter(c => (c.descricao || '').toUpperCase().includes(f) || String(c.codCen).includes(f))
      : this.centrosResultado;
  }

  descricaoCentroResultado(cod: string | number): string {
    return this.centrosResultado.find(c => String(c.codCen) === String(cod))?.descricao ?? '';
  }

  valorExibidoCentroResultado(cod: string | number): string {
    const desc = this.descricaoCentroResultado(cod);
    return desc ? `${cod} - ${desc}` : String(cod ?? '');
  }

  onInputCentroResultado(event: Event): void {
    const input = event.target as HTMLInputElement;
    const val   = input.value;
    const cur   = input.selectionStart ?? val.length;
    const idx   = val.indexOf(' - ');
    const cod   = idx >= 0 ? val.substring(0, idx) : val;
    this.centroResultadoSelecionado = cod;
    const novo = this.valorExibidoCentroResultado(cod);
    setTimeout(() => {
      input.value = novo;
      const pos = Math.min(cur, cod.length);
      input.setSelectionRange(pos, pos);
    });
  }

  abrirBuscaCentroResultado(): void {
    this.filtroCentroResultado = '';
    this.centroResultadoModalAberta = true;
    this._carregarCentrosResultado();
  }
  fecharBuscaCentroResultado(): void { this.centroResultadoModalAberta = false; }
  selecionarCentroResultado(c: { codCen: string | number; descricao: string }): void {
    this.centroResultadoSelecionado = c.codCen;
    this.centroResultadoModalAberta = false;
  }
  limparCentroResultado(): void { this.centroResultadoSelecionado = '0'; }

  // ── Projeto (CODPROJ) ─────────────────────────────────────
  projetos: { codProj: string | number; descricao: string }[] = [
    { codProj: '0', descricao: 'Nenhum' },
  ];
  // Default 1000000000 - GLOBAL PARTS IMPORTAÇÕES, fixo (confirmado com o
  // usuário -- não varia por Nacional/Importação, já que isso só é
  // descoberto depois, por item, e um mesmo pedido pode ter os dois).
  projetoSelecionado: string | number = '1000000000';
  projetoModalAberta  = false;
  filtroProjeto       = '';
  projetosCarregando  = false;

  get projetosFiltrados() {
    const f = this.filtroProjeto.trim().toUpperCase();
    return f
      ? this.projetos.filter(p => (p.descricao || '').toUpperCase().includes(f) || String(p.codProj).includes(f))
      : this.projetos;
  }

  descricaoProjeto(cod: string | number): string {
    return this.projetos.find(p => String(p.codProj) === String(cod))?.descricao ?? '';
  }

  valorExibidoProjeto(cod: string | number): string {
    const desc = this.descricaoProjeto(cod);
    return desc ? `${cod} - ${desc}` : String(cod ?? '');
  }

  onInputProjeto(event: Event): void {
    const input = event.target as HTMLInputElement;
    const val   = input.value;
    const cur   = input.selectionStart ?? val.length;
    const idx   = val.indexOf(' - ');
    const cod   = idx >= 0 ? val.substring(0, idx) : val;
    this.projetoSelecionado = cod;
    const novo = this.valorExibidoProjeto(cod);
    setTimeout(() => {
      input.value = novo;
      const pos = Math.min(cur, cod.length);
      input.setSelectionRange(pos, pos);
    });
  }

  abrirBuscaProjeto(): void {
    this.filtroProjeto = '';
    this.projetoModalAberta = true;
    this._carregarProjetos();
  }
  fecharBuscaProjeto(): void { this.projetoModalAberta = false; }
  selecionarProjeto(p: { codProj: string | number; descricao: string }): void {
    this.projetoSelecionado = p.codProj;
    this.projetoModalAberta = false;
  }
  limparProjeto(): void { this.projetoSelecionado = '0'; }

  // ── Cotação (VLRMOEDA) ──────────────────────────────────────
  cotacoesDisponiveis: DemonstrativoCotacao[] = [];
  cotacaoModalAberta  = false;
  cotacaoCarregando   = false;
  cotacaoTexto        = '';
  cotacaoSelecionada: DemonstrativoCotacao | null = null;
  filtroCotacao       = '';

  get cotacaoValorNumerico(): number {
    const raw = this.cotacaoSelecionada?.valor ?? this.cotacaoTexto?.split('|')[0].trim();
    return parseFloat(String(raw ?? '').replace(',', '.')) || 0;
  }

  get cotacoesFiltradas(): DemonstrativoCotacao[] {
    const t = this.filtroCotacao.trim().toLowerCase();
    return t
      ? this.cotacoesDisponiveis.filter(c =>
          String(c.valor ?? '').toLowerCase().includes(t) ||
          this._dataCotacao(c).toLowerCase().includes(t))
      : this.cotacoesDisponiveis;
  }

  private _dataCotacao(c: DemonstrativoCotacao): string {
    return String(c.data ?? c.DATA_BR ?? c.DATA ?? c.DTMOV ?? '');
  }

  private _fmtCotacao(c: DemonstrativoCotacao): string {
    const data = this._dataCotacao(c);
    return `${c.valor}${data ? '  |  ' + data : ''}`;
  }

  async abrirBuscaCotacao(): Promise<void> {
    this.filtroCotacao = '';
    this.cotacaoModalAberta = true;
    await this._carregarCotacoes();
  }

  fecharBuscaCotacao(): void { this.cotacaoModalAberta = false; }

  selecionarCotacao(c: DemonstrativoCotacao): void {
    this.cotacaoSelecionada = c;
    this.cotacaoTexto = this._fmtCotacao(c);
    this.cotacaoModalAberta = false;
    this._recalcularPrecos();
  }

  limparCotacao(): void {
    this.cotacaoSelecionada = null;
    this.cotacaoTexto = '';
    this._recalcularPrecos();
  }

  private _recalcularPrecos(): void {
    const taxa = this.cotacaoValorNumerico;
    for (const item of this.itens) {
      if (item.precoUsd > 0 && taxa > 0) {
        item.precoUnitario = parseFloat((item.precoUsd * taxa).toFixed(2));
        if (item.controlaCore && item.vlrCore > 0) {
          item.coreUnitBrl = parseFloat((item.vlrCore * taxa).toFixed(2));
        }
        this._calcularTotal(item);
      }
    }
  }

  // ── Itens ───────────────────────────────────────────────────
  private _proximoId = 2;

  itens: ItemCompra[] = [this._novoItem()];

  private _novoItem(): ItemCompra {
    return {
      id: this._proximoId++,
      codprod: '', descricao: '', unidade: 'UN',
      quantidade: 1, precoUsd: 0, precoUnitario: 0,
      desconto: 0, vlrDesc: 0, vlrAcrescDesc: 0,
      total: 0, totalUsd: 0, estoque: 0,
      controlaCore: false, vlrCore: 0, coreUnitBrl: 0, totalCoreBrl: 0,
    };
  }

  adicionarLinha(): void {
    this.itens.push(this._novoItem());
  }

  removerItem(id: number): void {
    this.itens = this.itens.filter(i => i.id !== id);
    if (this.itens.length === 0) this.itens.push(this._novoItem());   // último/único item: recria a linha vazia
  }

  get totalGeral(): number {
    return this.itens.reduce((s, i) => s + (i.total || 0), 0);
  }

  get totalGeralUsd(): number {
    return this.itens.reduce((s, i) => s + (i.totalUsd || 0), 0);
  }

  /** Soma do Total Core R$ de todos os itens -- exibido no rodapé da
   *  tabela, igual ao "Total Core U$" do Pedido de Venda. */
  get totalCoreGeral(): number {
    return this.itens.reduce((s, i) => s + (i.totalCoreBrl || 0), 0);
  }

  /**
   * Soma da coluna CUSTO TOTAL (custo unitário × quantidade) das linhas com
   * produto carregado -- o CUSTO que vem do Aerosys (EST_CUSTO) é em U$,
   * mesma unidade usada em "Total Pedido U$" -- por isso NÃO usa fmtMoeda
   * (que é R$) sozinho; ver totalCustoTotalAnaliticoBrl abaixo pra a
   * conversão usando a cotação do dia.
   */
  get totalCustoTotalAnaliticoUsd(): number {
    return this.itensValidos.reduce((s, i) => s + ((i.custoAnalitico ?? 0) * (i.quantidade || 0)), 0);
  }

  /** Custo Total convertido pra R$ pela cotação do dólar selecionada no
   *  pedido (cotacaoValorNumerico) -- mesma cotação usada pra calcular
   *  Preço R$ dos itens a partir do Preço U$. */
  get totalCustoTotalAnaliticoBrl(): number {
    return this.totalCustoTotalAnaliticoUsd * this.cotacaoValorNumerico;
  }

  get itensValidos(): ItemCompra[] {
    return this.itens.filter(i => i.codprodInterno && i.codprodInterno > 0);
  }

  _calcularTotal(item: ItemCompra): void {
    const base = item.quantidade * item.precoUnitario;
    item.total    = parseFloat((base - (item.vlrDesc || 0) + (item.vlrAcrescDesc || 0)).toFixed(2));
    const baseUsd = item.quantidade * item.precoUsd;
    item.totalUsd = item.precoUsd > 0
      ? parseFloat((baseUsd - baseUsd * ((item.desconto || 0) / 100)).toFixed(2))
      : 0;
    // Core rastreado só para exibição — já está embutido em precoUnitario quando ativo
    // (mesmo padrão do Pedido de Venda, ver totalCoreBrl/totalCoreUsd lá).
    item.totalCoreBrl = item.controlaCore ? parseFloat((item.quantidade * (item.coreUnitBrl ?? 0)).toFixed(2)) : 0;
  }

  onQtdChange(item: ItemCompra): void { this._calcularTotal(item); }

  onPrecoUsdBlur(item: ItemCompra, event: Event): void {
    const raw = (item.precoUsdStr ?? '').replace(',', '.');
    const val = parseFloat(raw);
    if (!isNaN(val)) {
      item.precoUsd = val;
      const taxa = this.cotacaoValorNumerico;
      if (taxa > 0) { item.precoUnitario = parseFloat((val * taxa).toFixed(2)); }
      item.precoUsdStr = this.fmtDecimal(val);
      this._calcularTotal(item);
    }
    (event.target as HTMLInputElement).value = item.precoUsdStr ?? '';
  }

  /** Sim/Não do Core — igual ao Pedido de Venda (toggleCore lá): soma/subtrai
   *  o valor do Core direto no preço unitário (U$ e R$), já que a tela
   *  mostra o unitário SEMPRE com Core embutido quando ativo. */
  toggleCore(item: ItemCompra): void {
    if (item.controlaCore) {
      // Sim → Não: remove Core do precoUsd (U$) e do precoUnitario (R$)
      const coreUsd = item.vlrCore ?? 0;
      const coreBrl = item.coreUnitBrl ?? 0;
      item.controlaCore  = false;
      item.coreUnitBrl    = 0;
      item.precoUsd      = parseFloat(Math.max(0, item.precoUsd - coreUsd).toFixed(2));
      item.precoUnitario = parseFloat(Math.max(0, item.precoUnitario - coreBrl).toFixed(2));
      item.precoUsdStr   = item.precoUsd > 0 ? this.fmtDecimal(item.precoUsd) : '';
      this._calcularTotal(item);
    } else {
      // Não → Sim: soma Core ao precoUsd (U$) e ao precoUnitario (R$)
      if (!(item.vlrCore > 0)) return;
      const taxa        = this.cotacaoValorNumerico;
      const coreUsd     = item.vlrCore;
      const coreUnitBrl = taxa > 0 ? parseFloat((coreUsd * taxa).toFixed(2)) : 0;
      item.controlaCore  = true;
      item.coreUnitBrl    = coreUnitBrl;
      item.precoUsd      = parseFloat((item.precoUsd + coreUsd).toFixed(2));
      item.precoUnitario = parseFloat((item.precoUnitario + coreUnitBrl).toFixed(2));
      item.precoUsdStr   = this.fmtDecimal(item.precoUsd);
      this._calcularTotal(item);
    }
  }

  onDescontoChange(item: ItemCompra): void {
    const base = item.quantidade * item.precoUnitario;
    if (base > 0) {
      item.vlrDesc = parseFloat((base * (item.desconto || 0) / 100).toFixed(2));
    }
    this._calcularTotal(item);
  }

  // ── Painel "Peças com Venda nos últimos X meses" (Aerosys + Sankhya) ──
  qtdeVendidaDtDe       = this._dataAnaliticoPadrao(-3);
  qtdeVendidaDtAte      = this._dataAnaliticoPadrao(0);
  qtdeVendidaCarregando = false;
  qtdeVendidaCarregada  = false;
  /** Dispara buscarQtdeVendida() sozinho (sem botão) sempre que item/data mudam, com debounce. */
  private _qtdeVendidaSubject = new Subject<void>();

  private _dataAnaliticoPadrao(deslocMeses: number): string {
    const d = new Date();
    d.setMonth(d.getMonth() + deslocMeses);
    const dd   = String(d.getDate()).padStart(2, '0');
    const mm   = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }

  /** NACIONAL=1 / IMPORTAÇÃO=12 -- mesmas constantes do dual-write no backend (PedidoCompraComponent) */
  private get _empresaAerosysDoTipo(): number {
    return this.tipoGpl === 'NACIONAL' ? 1 : 12;
  }

  /** Chamar sempre que item ou data do filtro mudarem -- dispara buscarQtdeVendida() sozinho, com debounce. */
  onFiltroQtdeVendidaMudou(): void {
    this._qtdeVendidaSubject.next();
  }

  async buscarQtdeVendida(): Promise<void> {
    const codProds = Array.from(new Set(
      this.itens
        .map(i => i.codprodInterno)
        .filter((c): c is number => !!c && c > 0)
    ));
    if (codProds.length === 0) return;

    const codEmpSankhya = parseInt(this.empresaState.codEmpReal ?? '0', 10) || 0;
    if (!codEmpSankhya) return;

    this.qtdeVendidaCarregando = true;
    try {
      // Em lotes -- o Oracle rejeita CODPROD IN (...) com mais de 1000
      // itens (ORA-01795), e o lado Aerosys tem várias subqueries
      // correlacionadas por item na mesma consulta, então uma lista muito
      // grande de uma vez só também fica pesada/lenta demais e tende a dar
      // timeout. Antes da importação em massa (Funções > Peças com Venda)
      // um pedido nunca passava de umas dezenas de itens, então esse limite
      // nunca tinha sido alcançado -- com 1000+ itens de uma vez ele batia
      // direto no ORA-01795 e a chamada inteira falhava silenciosamente
      // (erro só ia pro console, ver comentário abaixo), deixando todas as
      // colunas desse painel em branco pros itens importados.
      const TAMANHO_LOTE = 300;
      const CONCORRENCIA = 3;
      const lotes: number[][] = [];
      for (let i = 0; i < codProds.length; i += TAMANHO_LOTE) {
        lotes.push(codProds.slice(i, i + TAMANHO_LOTE));
      }
      for (let i = 0; i < lotes.length; i += CONCORRENCIA) {
        const grupo = lotes.slice(i, i + CONCORRENCIA);
        await Promise.all(grupo.map(lote => this._aplicarQtdeVendidaLote(lote, codEmpSankhya)));
      }
      this.qtdeVendidaCarregada = true;
    } catch {
      // Painel de apoio à decisão -- falha não pode travar a tela do pedido
    } finally {
      this.qtdeVendidaCarregando = false;
    }
  }

  /** Busca e aplica o painel "Peças com Venda" pra 1 lote de CODPROD (ver
   *  motivo do lote em buscarQtdeVendida() acima). Falha isolada de um lote
   *  não derruba os demais -- cada lote atualiza os itens dele independente. */
  private async _aplicarQtdeVendidaLote(codProds: number[], codEmpSankhya: number): Promise<void> {
    try {
      const res: any = await firstValueFrom(
        this.gateway.buscarAnaliticoItensPedidoCompra(
          codProds, codEmpSankhya, this._empresaAerosysDoTipo,
          this.qtdeVendidaDtDe, this.qtdeVendidaDtAte
        ).pipe(timeout(30000))
      );
      // Backend devolve { itens, erroAerosys, erroSankhya } -- os erros (se
      // houver) são só pra diagnóstico (aba Network/Console), o painel
      // continua mostrando o que der (Aerosys e Sankhya são independentes).
      const linhas: any[] = Array.isArray(res) ? res : (res?.itens ?? []);
      if (res?.erroAerosys) console.warn('[Qtde Vendida] Aerosys:', res.erroAerosys);
      if (res?.erroSankhya) console.warn('[Qtde Vendida] Sankhya:', res.erroSankhya);
      const porCodProd = new Map<number, any>();
      for (const l of linhas) {
        if (l?.codProd != null) porCodProd.set(Number(l.codProd), l);
      }
      for (const item of this.itens) {
        if (!item.codprodInterno) continue;
        const dados = porCodProd.get(item.codprodInterno);
        if (!dados) continue;
        item.cd                = dados.cd ?? undefined;
        item.custoAnalitico    = dados.custo ?? null;
        item.pontoPedido       = dados.pontoPedido ?? null;
        item.estoqueEua        = dados.estoqueEua ?? null;
        item.qtdeVendas        = dados.qtdeVendas ?? null;
        item.qtdeVendasAnoAnt  = dados.qtdeVendasAnoAnt ?? null;
        item.qtdePedidoOutros  = dados.qtdePedidoOutros ?? null;
        item.pedidoOutros      = dados.pedidoOutros ?? '';
        item.qtdePrecompraAbBk = dados.qtdePrecompraAbBk ?? null;
        item.dataPrecompraAbBk = dados.dataPrecompraAbBk ?? '';
      }
    } catch {
      // 1 lote falhando não pode travar os demais.
    }
  }

  // ── "Funções" (engrenagem) — menu do cabeçalho de Itens do Pedido ──
  funcoesMenuAberto = false;

  toggleFuncoesMenu(event?: Event): void {
    event?.stopPropagation();
    this.funcoesMenuAberto = !this.funcoesMenuAberto;
  }

  fecharFuncoesMenu(): void {
    this.funcoesMenuAberto = false;
  }

  @HostListener('document:click')
  onDocumentClickFecharFuncoesMenu(): void {
    if (this.funcoesMenuAberto) this.funcoesMenuAberto = false;
  }

  // ── "Funções > Imp. Peças com Venda nos últimos X meses" (checklist) ───
  // Lista de DESCOBERTA (Aerosys + Sankhya reconciliados), respeitando o
  // mesmo período já selecionado no filtro qtdeVendidaDtDe/DtAte -- exclui
  // venda em aberto e orçamento dos dois lados (ver comentários no backend:
  // PedidoCompraAnaliticoComponent#buscarDescoberta). Confirmar adiciona os
  // itens marcados como novas linhas no grid, Quantidade = 1, mesmo padrão
  // da Importação de Excel (confirmarImportacaoExcel).
  descobertaAberta      = false;
  descobertaCarregando  = false;
  descobertaImportando  = false;
  descobertaProgressoFeito  = 0;
  descobertaProgressoTotal  = 0;
  descobertaErro: string | null = null;
  descobertaItens: { codProd: number; pn: string; descricao: string; qtdeVendas: number; marcado: boolean; unidade?: string; codLocalPadrao?: number; codLocalOrigem?: number; cd?: string; origemItem?: 'SANKHYA' | 'AEROSYS'; headerIdOrigem?: number; seqOrigem?: number; qtdeOrigem?: number; custoPedidoBrl?: number; cotacaoPedido?: number; pedidoNacional?: boolean; itemId?: number; statusItem?: string; numTituloPedido?: string; previsaoEntrega?: string; obs?: string; pciId?: number; pcpId?: number }[] = [];
  /** De onde os itens desse checklist vieram -- controla o título/badge do
   *  cabeçalho do modal, já que o mesmo checklist é reaproveitado tanto por
   *  "Imp. Peças com Venda nos últimos X meses" (período) quanto por
   *  "Imp. Peças de uma seleção de Vendas" (vendas escolhidas na busca). */
  descobertaOrigem: 'periodo' | 'vendas' | 'fabricante' | 'pedidos' = 'periodo';
  descobertaOrigemDetalhe = '';

  get descobertaMarcadosCount(): number {
    return this.descobertaItens.filter(i => i.marcado).length;
  }

  get descobertaTodosMarcados(): boolean {
    return this.descobertaItens.length > 0 && this.descobertaItens.every(i => i.marcado);
  }

  async abrirDescobertaPecasComVenda(): Promise<void> {
    this.fecharFuncoesMenu();
    const codEmpSankhya = parseInt(this.empresaState.codEmpReal ?? '0', 10) || 0;
    if (!codEmpSankhya) {
      this.abrirAlerta('Selecione a empresa da compra antes de importar peças com venda.', 'aviso');
      return;
    }
    this.descobertaOrigem     = 'periodo';
    this.descobertaAberta     = true;
    this.descobertaCarregando = true;
    this.descobertaErro       = null;
    this.descobertaItens      = [];
    try {
      const res: any = await firstValueFrom(
        this.gateway.buscarDescobertaPecasComVenda(
          codEmpSankhya, this._empresaAerosysDoTipo,
          this.qtdeVendidaDtDe, this.qtdeVendidaDtAte
        )
      );
      const linhas: any[] = Array.isArray(res) ? res : (res?.itens ?? []);
      this.descobertaItens = linhas
        .filter(l => l?.pn)
        .map(l => ({
          codProd:        Number(l.codProd) || 0,
          pn:             String(l.pn),
          descricao:      l.descricao ?? '',
          qtdeVendas:     Number(l.qtdeVendas) || 0,
          marcado:        true,
          unidade:        l.unidade || undefined,
          codLocalPadrao: Number(l.codLocalPadrao) || undefined,
          cd:             l.cd || undefined,
        }));
      if (this.descobertaItens.length === 0) {
        this.descobertaErro = 'Nenhuma peça com venda fechada nesse período.';
      }
    } catch {
      this.descobertaErro = 'Não foi possível buscar as peças com venda no período. Tente novamente.';
    } finally {
      this.descobertaCarregando = false;
    }
  }

  toggleDescobertaTodos(): void {
    const marcarTodos = !this.descobertaTodosMarcados;
    this.descobertaItens.forEach(i => i.marcado = marcarTodos);
  }

  fecharDescoberta(): void {
    this.descobertaAberta = false;
    this.descobertaItens  = [];
    this.descobertaErro   = null;
  }

  // ── "Funções > Imp. Peças de uma seleção de Vendas" (Geral / Apenas
  // Importação) ────────────────────────────────────────────────────────
  // Busca vendas (Aerosys + Sankhya) por cliente/NUNOTA/N° título, permite
  // marcar várias, e reaproveita o MESMO checklist (descobertaItens/
  // descobertaAberta/confirmarDescoberta) já usado por "Imp. Peças com
  // Venda" acima pra revisar e importar os itens combinados.
  buscaVendasAberta           = false;
  buscaVendasApenasImportacao = false;
  buscaVendasTermo            = '';
  buscaVendasCarregando       = false;
  buscaVendasErro: string | null = null;
  buscaVendasResultados: {
    sistema: 'sankhya' | 'aerosys'; id: number; numero: string;
    cliente: string; data: string; dataOrdenavel: number; valor: number; tipo: string; status?: string; marcado: boolean;
  }[] = [];
  /** Clique no cabeçalho da coluna reordena (mesmo padrão de
   *  ordenarBuscaPecas() no modal F3, sem os filtros inline por coluna --
   *  aqui é só reordenação). */
  buscaVendasOrdenarCampo: string | null = null;
  buscaVendasOrdemAsc = true;

  get buscaVendasMarcadosCount(): number {
    return this.buscaVendasResultados.filter(v => v.marcado).length;
  }

  ordenarBuscaVendas(campo: string): void {
    if (this.buscaVendasOrdenarCampo === campo) {
      this.buscaVendasOrdemAsc = !this.buscaVendasOrdemAsc;
    } else {
      this.buscaVendasOrdenarCampo = campo;
      this.buscaVendasOrdemAsc = true;
    }
    const dir = this.buscaVendasOrdemAsc ? 1 : -1;
    // "data" usa o campo numérico auxiliar (dataOrdenavel) pra ordenar
    // cronologicamente -- comparar a string formatada "DD/MM/YYYY HH:mm"
    // como texto ordenaria pelo dia primeiro, não pela data real.
    const campoReal = campo === 'data' ? 'dataOrdenavel' : campo;
    this.buscaVendasResultados = [...this.buscaVendasResultados].sort((a, b) => {
      const va = (a as any)[campoReal];
      const vb = (b as any)[campoReal];
      if (va == null && vb == null) return 0;
      if (va == null) return 1;
      if (vb == null) return -1;
      if (typeof va === 'string' && typeof vb === 'string') return va.localeCompare(vb, 'pt-BR') * dir;
      return ((va as number) - (vb as number)) * dir;
    });
  }

  abrirBuscaVendas(apenasImportacao: boolean): void {
    this.fecharFuncoesMenu();
    this.buscaVendasApenasImportacao = apenasImportacao;
    this.buscaVendasTermo            = '';
    this.buscaVendasResultados       = [];
    this.buscaVendasErro             = null;
    this.buscaVendasAberta           = true;
    setTimeout(() => document.getElementById('pcf-busca-vendas-input')?.focus(), 60);
  }

  fecharBuscaVendas(): void {
    this.buscaVendasAberta     = false;
    this.buscaVendasResultados = [];
    this.buscaVendasErro       = null;
  }

  /** Sankhya já vem formatado "DD/MM/YYYY HH:mm" (TO_CHAR no backend) --
   *  passa direto. Aerosys vem cru do banco (ISO, ex.:
   *  "2026-08-11T17:53:41.274Z"), sem formatação nenhuma -- formata aqui
   *  pro mesmo padrão, senão a coluna Data fica com dois formatos
   *  diferentes lado a lado na mesma tabela. */
  private _formatarDataBuscaVendas(data: string): string {
    if (!data) return '';
    if (data.includes('/')) return data;
    const d = new Date(data);
    if (isNaN(d.getTime())) return data;
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  /** Valor numérico (epoch ms) da mesma data acima, só pra ordenar a coluna
   *  Data cronologicamente -- comparar "DD/MM/YYYY HH:mm" como texto
   *  ordenaria pelo dia primeiro, não pela data real. */
  private _dataOrdenavelBuscaVendas(data: string): number {
    if (!data) return 0;
    if (data.includes('/')) {
      const m = data.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2}))?/);
      if (!m) return 0;
      const [, dd, mm, yyyy, hh, min] = m;
      return new Date(Number(yyyy), Number(mm) - 1, Number(dd), Number(hh || 0), Number(min || 0)).getTime();
    }
    const t = new Date(data).getTime();
    return isNaN(t) ? 0 : t;
  }

  async buscarVendas(): Promise<void> {
    const termo = this.buscaVendasTermo.trim();
    if (!termo) { this.buscaVendasResultados = []; this.buscaVendasErro = null; return; }
    const codEmpSankhya = parseInt(this.empresaState.codEmpReal ?? '0', 10) || 0;
    if (!codEmpSankhya) {
      this.abrirAlerta('Selecione a empresa da compra antes de buscar vendas.', 'aviso');
      return;
    }

    this.buscaVendasCarregando = true;
    this.buscaVendasErro       = null;
    try {
      const res: any = await firstValueFrom(
        this.gateway.buscarVendasPorTermo(
          codEmpSankhya, this._empresaAerosysDoTipo, termo, this.buscaVendasApenasImportacao
        ).pipe(timeout(20000))
      );
      // Antes esses erros só iam pro console (invisível pro usuário) -- se
      // um dos dois sistemas falhar (ex.: Sankhya) enquanto o outro
      // funciona, a tela parecia "só carrega Aerosys" sem explicação
      // nenhuma. Agora aparece como aviso mesmo quando o outro lado trouxe
      // resultado.
      const avisos: string[] = [];
      if (res?.erroAerosys) { console.warn('[Busca Vendas] Aerosys:', res.erroAerosys); avisos.push('Aerosys: ' + res.erroAerosys); }
      if (res?.erroSankhya) { console.warn('[Busca Vendas] Sankhya:', res.erroSankhya); avisos.push('Sankhya: ' + res.erroSankhya); }
      const linhas: any[] = res?.vendas ?? [];
      this.buscaVendasResultados = linhas.map((v: any) => ({
        sistema:       v.sistema,
        id:            Number(v.id) || 0,
        numero:        String(v.numero ?? ''),
        cliente:       v.cliente ?? '',
        data:          this._formatarDataBuscaVendas(v.data),
        dataOrdenavel: this._dataOrdenavelBuscaVendas(v.data),
        valor:         Number(v.valor) || 0,
        tipo:          v.tipo ?? '',
        status:        v.status ?? '',
        marcado:       false,
      }));
      if (this.buscaVendasResultados.length === 0) {
        this.buscaVendasErro = avisos.length > 0 ? avisos.join(' | ') : 'Nenhuma venda encontrada pra esse termo.';
      } else {
        this.buscaVendasErro = avisos.length > 0 ? avisos.join(' | ') : null;
      }
    } catch {
      this.buscaVendasErro = 'Não foi possível buscar as vendas. Tente novamente.';
    } finally {
      this.buscaVendasCarregando = false;
    }
  }

  /** Busca os itens combinados das vendas marcadas e abre o checklist de
   *  importação (descobertaAberta) já reaproveitado de "Imp. Peças com
   *  Venda" -- confirmarDescoberta() dali importa os itens marcados. */
  async confirmarSelecaoVendas(): Promise<void> {
    const marcadas = this.buscaVendasResultados.filter(v => v.marcado);
    if (marcadas.length === 0) return;

    this.buscaVendasCarregando = true;
    try {
      const res: any = await firstValueFrom(
        this.gateway.buscarItensDeVendasSelecionadas(
          this._empresaAerosysDoTipo,
          marcadas.map(v => ({ sistema: v.sistema, id: v.id }))
        ).pipe(timeout(30000))
      );
      const linhas: any[] = res?.itens ?? [];
      const erros: string[] = res?.erros ?? [];
      this.descobertaItens = linhas
        .filter((l: any) => l?.pn)
        .map((l: any) => ({
          codProd:        Number(l.codProd) || 0,
          pn:             String(l.pn),
          descricao:      l.descricao ?? '',
          qtdeVendas:     Number(l.qtde) || 0,
          marcado:        true,
          unidade:        l.unidade || undefined,
          codLocalPadrao: Number(l.codLocalPadrao) || undefined,
          cd:             l.cd || undefined,
        }));
      this.fecharBuscaVendas();
      this.descobertaOrigem        = 'vendas';
      this.descobertaOrigemDetalhe = marcadas.length + (marcadas.length === 1 ? ' venda selecionada' : ' vendas selecionadas');
      this.descobertaAberta = true;
      // Mostra o motivo real (venda sem itens, erro Aerosys/Sankhya, etc.)
      // em vez de um "nenhum item" genérico -- antes isso ficava 100%
      // silencioso e só aparecia "0 itens" sem explicação nenhuma.
      this.descobertaErro = this.descobertaItens.length === 0
        ? (erros.length > 0 ? erros.join(' | ') : 'Nenhum item encontrado nas vendas selecionadas.')
        : null;
    } catch {
      this.buscaVendasErro = 'Não foi possível buscar os itens das vendas selecionadas. Tente novamente.';
    } finally {
      this.buscaVendasCarregando = false;
    }
  }

  // ── "Funções > Imp. Peças de um Fabricante" ─────────────────────────────
  // Por ora só lista os fabricantes combinados (Sankhya TGFMAR + Aerosys
  // FABRICANTE, reconciliados por código no backend -- ver
  // BuscaFabricanteComponent). A seleção/importação de peças por fabricante
  // vem numa etapa seguinte, a pedido do usuário ("pode começar listando os
  // fabricantes inicialmente").
  buscaFabricanteAberta      = false;
  buscaFabricanteCarregando  = false;
  buscaFabricanteErro: string | null = null;
  buscaFabricanteTermo       = '';
  buscaFabricanteLista: { codigo: number; nome: string; sankhya: boolean; aerosys: boolean }[] = [];
  /** Já carregado nessa sessão do form -- evita rebuscar toda vez que o
   *  usuário reabre o modal (lista de fabricantes muda raramente). */
  private _fabricantesJaCarregados = false;

  /** Clique no cabeçalho da coluna reordena (mesmo padrão de
   *  ordenarBuscaVendas() acima). */
  buscaFabricanteOrdenarCampo: string | null = null;
  buscaFabricanteOrdemAsc = true;

  get buscaFabricanteListaFiltrada(): { codigo: number; nome: string; sankhya: boolean; aerosys: boolean }[] {
    const termo = this.buscaFabricanteTermo.trim().toLowerCase();
    if (!termo) return this.buscaFabricanteLista;
    return this.buscaFabricanteLista.filter(f =>
      f.nome.toLowerCase().includes(termo) || String(f.codigo).includes(termo)
    );
  }

  ordenarBuscaFabricante(campo: string): void {
    if (this.buscaFabricanteOrdenarCampo === campo) {
      this.buscaFabricanteOrdemAsc = !this.buscaFabricanteOrdemAsc;
    } else {
      this.buscaFabricanteOrdenarCampo = campo;
      this.buscaFabricanteOrdemAsc = true;
    }
    const dir = this.buscaFabricanteOrdemAsc ? 1 : -1;
    this.buscaFabricanteLista = [...this.buscaFabricanteLista].sort((a: any, b: any) => {
      // "sistemas" não é um campo direto -- ordena por Sankhya+Aerosys(2) >
      // só um dos dois(1), pra agrupar "nos dois sistemas" primeiro/último.
      const va = campo === 'sistemas' ? (Number(a.sankhya) + Number(a.aerosys)) : a[campo];
      const vb = campo === 'sistemas' ? (Number(b.sankhya) + Number(b.aerosys)) : b[campo];
      if (va == null && vb == null) return 0;
      if (va == null) return 1;
      if (vb == null) return -1;
      if (typeof va === 'string' && typeof vb === 'string') return va.localeCompare(vb, 'pt-BR') * dir;
      return ((va as number) - (vb as number)) * dir;
    });
  }

  abrirBuscaFabricante(): void {
    this.fecharFuncoesMenu();
    this.buscaFabricanteTermo   = '';
    this.buscaFabricanteAberta  = true;
    if (!this._fabricantesJaCarregados) {
      this._carregarFabricantes();
    }
  }

  fecharBuscaFabricante(): void {
    this.buscaFabricanteAberta = false;
  }

  private async _carregarFabricantes(): Promise<void> {
    this.buscaFabricanteCarregando = true;
    this.buscaFabricanteErro       = null;
    try {
      const res: any = await firstValueFrom(
        this.gateway.listarFabricantes().pipe(timeout(20000))
      );
      const avisos: string[] = [];
      if (res?.erroAerosys) { console.warn('[Busca Fabricante] Aerosys:', res.erroAerosys); avisos.push('Aerosys: ' + res.erroAerosys); }
      if (res?.erroSankhya) { console.warn('[Busca Fabricante] Sankhya:', res.erroSankhya); avisos.push('Sankhya: ' + res.erroSankhya); }
      const linhas: any[] = res?.fabricantes ?? [];
      this.buscaFabricanteLista = linhas.map((f: any) => ({
        codigo:  Number(f.codigo) || 0,
        nome:    f.nome ?? '',
        sankhya: !!f.sankhya,
        aerosys: !!f.aerosys,
      }));
      this._fabricantesJaCarregados = true;
      if (this.buscaFabricanteLista.length === 0) {
        this.buscaFabricanteErro = avisos.length > 0 ? avisos.join(' | ') : 'Nenhum fabricante encontrado.';
      } else {
        this.buscaFabricanteErro = avisos.length > 0 ? avisos.join(' | ') : null;
      }
    } catch {
      this.buscaFabricanteErro = 'Não foi possível carregar os fabricantes. Tente novamente.';
    } finally {
      this.buscaFabricanteCarregando = false;
    }
  }

  /** Clique numa linha do fabricante -- carrega as peças dele (Sankhya
   *  TGFPRO.CODMARCA + Aerosys ADENDO_PECAS.FAB_ID, combinados no backend)
   *  e abre o MESMO checklist (descobertaAberta) já reaproveitado pelas
   *  outras duas origens ("periodo" e "vendas"). */
  buscaFabricanteCarregandoItens = false;

  async selecionarFabricante(f: { codigo: number; nome: string }): Promise<void> {
    if (this.buscaFabricanteCarregandoItens) return;
    this.buscaFabricanteCarregandoItens = true;
    try {
      const res: any = await firstValueFrom(
        this.gateway.buscarItensFabricante(f.codigo).pipe(timeout(30000))
      );
      const linhas: any[] = res?.itens ?? [];
      const erros: string[] = res?.erros ?? [];
      this.descobertaItens = linhas
        .filter((l: any) => l?.pn)
        .map((l: any) => ({
          codProd:        Number(l.codProd) || 0,
          pn:             String(l.pn),
          descricao:      l.descricao ?? '',
          qtdeVendas:     0,
          marcado:        true,
          unidade:        l.unidade || undefined,
          codLocalPadrao: Number(l.codLocalPadrao) || undefined,
          cd:             l.cd || undefined,
        }));
      this.fecharBuscaFabricante();
      this.descobertaOrigem        = 'fabricante';
      this.descobertaOrigemDetalhe = f.nome;
      this.descobertaAberta = true;
      this.descobertaErro = this.descobertaItens.length === 0
        ? (erros.length > 0 ? erros.join(' | ') : 'Nenhuma peça encontrada para esse fabricante.')
        : null;
    } catch {
      this.buscaFabricanteErro = 'Não foi possível carregar as peças desse fabricante. Tente novamente.';
    } finally {
      this.buscaFabricanteCarregandoItens = false;
    }
  }

  // ── "Funções > Importar Pré-Compras" ────────────────────────────────────
  // Lista as Pré-Compras AUTORIZADAS ou em BACKORDERS (Sankhya TOP 1301/1303 + Aerosys), já
  // deduplicadas (uma pré-compra gravada nos dois sistemas aparece UMA vez, origem "AMBOS").
  // Confirmar abre o MESMO checklist de itens (descobertaAberta, origem 'pedidos'). Ao salvar,
  // os itens de pré-compra do Sankhya são FATURADOS para a TOP da compra (1401/1408) e a pré-compra
  // de origem tem o status movimentado (COMPRADO / BACKORDERS) no Sankhya e no Aerosys.
  preComprasAberta     = false;
  preComprasCarregando = false;
  preComprasErro: string | null = null;
  preComprasTermo      = '';
  preComprasLista: {
    origem: 'SANKHYA' | 'AEROSYS' | 'AMBOS';
    label: string;
    nunotaSankhya?: number;
    pcpIdAerosys?: number;
    dataEmissao: string;
    fornecedor: string;
    descricao: string;
    status: string;
    tipo: string;
    numTitulo: string;
    prioridade: string;
    codEmp: string;
    solicitante: string;
    marcado: boolean;
  }[] = [];

  /** Pré-compras (PCP_ID Aerosys) selecionadas -- vão em cabecalho.idsPreCompraAerosys (CPR_IDS_FORCOTACAO). */
  private _idsPreCompraAerosysSelecionados = new Set<number>();
  private _idsPreCompraSankhyaSelecionados = new Set<number>();

  get preComprasListaFiltrada() {
    const termo = this.preComprasTermo.trim().toLowerCase();
    const chave = (p: any) => Number(p.nunotaSankhya ?? p.pcpIdAerosys ?? 0);
    // O 1º marcado define o tipo (NACIONAL/IMPORTAÇÃO): a lista passa a mostrar só esse tipo até desmarcar tudo.
    const tipoTravado = this.preComprasLista.find(p => p.marcado)?.tipo;
    const base = [...this.preComprasLista]
      .filter(p => !tipoTravado || !p.tipo || p.tipo === tipoTravado)
      .sort((a, b) => chave(b) - chave(a));
    if (!termo) return base;
    return base.filter(p =>
      p.label.toLowerCase().includes(termo) ||
      p.fornecedor.toLowerCase().includes(termo) ||
      (p.numTitulo ?? '').toLowerCase().includes(termo) ||
      (p.descricao ?? '').toLowerCase().includes(termo) ||
      String(p.nunotaSankhya ?? '').includes(termo) ||
      String(p.pcpIdAerosys ?? '').includes(termo)
    );
  }

  get preComprasMarcadosCount(): number {
    return this.preComprasLista.filter(p => p.marcado).length;
  }

  async abrirImportarPreCompras(): Promise<void> {
    this.fecharFuncoesMenu();
    const codEmp = parseInt(this.empresaState.codEmpReal ?? '0', 10) || 0;
    if (!codEmp) {
      this.abrirAlerta('Selecione a empresa da compra antes de importar Pré-Compras.', 'aviso');
      return;
    }
    this.preComprasTermo      = '';
    this.preComprasAberta     = true;
    this.preComprasCarregando = true;
    this.preComprasErro       = null;
    this.preComprasLista      = [];
    try {
      const res: any = await firstValueFrom(this.gateway.buscarPreComprasCombinadas(codEmp).pipe(timeout(30000)));
      const avisos: string[] = [];
      if (res?.erroAerosys) avisos.push('Aerosys: ' + res.erroAerosys);
      if (res?.erroSankhya) avisos.push('Sankhya: ' + res.erroSankhya);
      const linhas: any[] = res?.pedidos ?? [];
      this.preComprasLista = linhas.map((p: any) => ({
        origem:        p.origem,
        label:         p.label ?? '',
        nunotaSankhya: p.nunotaSankhya ? Number(p.nunotaSankhya) : undefined,
        pcpIdAerosys:  p.pcpIdAerosys != null ? Number(p.pcpIdAerosys) : undefined,
        dataEmissao:   p.dataEmissao ?? '',
        fornecedor:    p.fornecedor ?? '',
        descricao:     p.descricao ?? '',
        status:        p.status ?? '',
        tipo:          p.tipo ?? '',
        numTitulo:     p.numTitulo ?? '',
        prioridade:    p.prioridade ?? '',
        codEmp:        p.codEmp ?? '',
        solicitante:   p.solicitante ?? '',
        marcado:       false,
      }));
      this.preComprasErro = this.preComprasLista.length === 0
        ? (avisos.length > 0 ? avisos.join(' | ') : 'Nenhuma Pré-Compra AUTORIZADA ou em BACKORDERS encontrada.')
        : (avisos.length > 0 ? avisos.join(' | ') : null);
    } catch {
      this.preComprasErro = 'Não foi possível carregar as Pré-Compras. Tente novamente.';
    } finally {
      this.preComprasCarregando = false;
    }
  }

  /** Data como dd/MM/yyyy (o Aerosys manda ISO, o Sankhya já manda dd/MM/yyyy). */
  formatarDataPedidoCompra(v: string): string {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v ?? '');
    return m ? `${m[3]}/${m[2]}/${m[1]}` : (v ?? '');
  }

  fecharImportarPreCompras(): void {
    this.preComprasAberta = false;
    this.preComprasLista  = [];
    this.preComprasErro   = null;
  }

  private _snapshotIdsPreCompras: { aerosys: Set<number>; sankhya: Set<number> } | null = null;

  async confirmarSelecaoPreCompras(): Promise<void> {
    const marcados = this.preComprasLista.filter(p => p.marcado);
    if (marcados.length === 0) return;

    this.preComprasCarregando = true;
    try {
      this._snapshotIdsPreCompras = {
        aerosys: new Set(this._idsPreCompraAerosysSelecionados),
        sankhya: new Set(this._idsPreCompraSankhyaSelecionados),
      };
      for (const p of marcados) {
        if (p.pcpIdAerosys != null)  this._idsPreCompraAerosysSelecionados.add(p.pcpIdAerosys);
        if (p.nunotaSankhya != null) this._idsPreCompraSankhyaSelecionados.add(p.nunotaSankhya);
      }
      this._atualizarNumPoPreCompras();

      // O TIPO da compra (e portanto a TOP: 1401 nacional / 1408 importação) segue a pré-compra selecionada.
      const tipoOrigem = marcados.find(p => p.tipo)?.tipo;
      if (tipoOrigem) {
        this.tipoGpl = tipoOrigem.toUpperCase().startsWith('NAC') ? 'NACIONAL' : 'IMPORTACAO';
        this.aoMudarTipoGpl();
      }
      // Fornecedor: o da 1ª pré-compra do Sankhya, quando a compra ainda não tem fornecedor escolhido.
      await this._preencherCabecalhoDasPreCompras(marcados.find(p => p.nunotaSankhya != null)?.nunotaSankhya);

      const res: any = await firstValueFrom(
        this.gateway.buscarItensPreComprasSelecionadas(
          marcados.map(p => ({ nunotaSankhya: p.nunotaSankhya ?? null, pcpIdAerosys: p.pcpIdAerosys ?? null }))
        ).pipe(timeout(30000))
      );
      const linhas: any[] = Array.isArray(res) ? res : (res?.itens ?? []);
      const erros: string[] = Array.isArray(res) ? [] : (res?.erros ?? []);
      const titulos = new Map<string, string>();
      for (const p of marcados) {
        if (p.nunotaSankhya != null) titulos.set(`SANKHYA:${p.nunotaSankhya}`, p.numTitulo);
        if (p.pcpIdAerosys != null)  titulos.set(`AEROSYS:${p.pcpIdAerosys}`, p.numTitulo);
      }
      this.descobertaItens = linhas
        .filter((l: any) => l?.pn || l?.codprod)
        .map((l: any) => ({
          codProd:        Number(l.codprod) || 0,
          pn:             String(l.pn || l.codprod || ''),
          descricao:      l.descricao ?? '',
          qtdeVendas:     0,
          marcado:        true,
          unidade:        l.unidade || undefined,
          codLocalOrigem: Number(l.codlocal) > 0 ? Number(l.codlocal) : undefined,
          origemItem:     l.origemItem,
          headerIdOrigem: l.headerId != null ? Number(l.headerId) : undefined,
          seqOrigem:      Number(l.sequencia) > 0 ? Number(l.sequencia) : undefined,
          qtdeOrigem:     Number(l.quantidade) > 0 ? Number(l.quantidade) : undefined,
          custoPedidoBrl: Number(l.vlrunit) > 0 ? Number(l.vlrunit) : undefined,
          cotacaoPedido:  Number(l.cotacaoPedido) > 0 ? Number(l.cotacaoPedido) : undefined,
          pedidoNacional: l.nacional === true,
          itemId:         Number(l.itemId) > 0 ? Number(l.itemId) : undefined,
          statusItem:     String(l.statusItem || '').toUpperCase() || 'ABERTO',
          numTituloPedido: titulos.get(`${l.origemItem}:${l.headerId}`) ?? '',
          previsaoEntrega: String(l.previsaoEntrega ?? ''),
          obs:            String(l.obs ?? ''),
          pciId:          Number(l.pciId) > 0 ? Number(l.pciId) : undefined,
          pcpId:          Number(l.pcpId) > 0 ? Number(l.pcpId) : undefined,
        }));
      this.preComprasAberta        = false;
      this.descobertaOrigem        = 'pedidos';
      this.descobertaOrigemDetalhe = marcados.length + (marcados.length === 1 ? ' pré-compra selecionada' : ' pré-compras selecionadas');
      this.descobertaAberta = true;
      this.descobertaErro = this.descobertaItens.length === 0
        ? (erros.length > 0 ? erros.join(' | ') : 'Nenhum item encontrado nas Pré-Compras selecionadas.')
        : (erros.length > 0 ? erros.join(' | ') : null);
    } catch {
      this.preComprasErro = 'Não foi possível buscar os itens das pré-compras selecionadas. Tente novamente.';
    } finally {
      this.preComprasCarregando = false;
    }
  }

  /** Botão "Voltar" do checklist de itens: volta pra lista de pré-compras (mantendo as marcações). */
  voltarParaListaPreCompras(): void {
    if (this._snapshotIdsPreCompras) {
      this._idsPreCompraAerosysSelecionados = new Set(this._snapshotIdsPreCompras.aerosys);
      this._idsPreCompraSankhyaSelecionados = new Set(this._snapshotIdsPreCompras.sankhya);
      this._snapshotIdsPreCompras = null;
      this._atualizarNumPoPreCompras();
    }
    this.fecharDescoberta();
    this.preComprasAberta = true;
  }

  private _numPoAuto = '';

  /** Nº PO = pré-compras de origem (Sankhya: NUNOTA; Aerosys: "AE" + PCP_ID). */
  private _atualizarNumPoPreCompras(): void {
    const ids = [
      ...Array.from(this._idsPreCompraSankhyaSelecionados).map(String),
      ...Array.from(this._idsPreCompraAerosysSelecionados).map(i => 'AE' + i),
    ];
    const novo = ids.join(', ');
    if (!this.numPo || this.numPo === this._numPoAuto) {
      this.numPo = novo;
    }
    this._numPoAuto = novo;
  }

  /** Cabeçalho a partir da 1ª pré-compra do Sankhya (fornecedor), sem sobrescrever o que o usuário já escolheu. */
  private async _preencherCabecalhoDasPreCompras(nunota?: number): Promise<void> {
    if (!nunota || this.fornecedorSelecionado) return;
    try {
      const res: any = await firstValueFrom(this.gateway.buscarDetalhesPedidoVenda(nunota));
      const body = res?.responseBody ?? res;
      const d = body?.sucesso ? (body.detalhe ?? body) : null;
      if (!d || !d.codparc) return;
      this.selecionarFornecedor({
        codparc: String(d.codparc),
        nomeparc: d.cliente ?? '',
        docparc: d.docparc ?? '',
      });
    } catch {
      // best-effort
    }
  }

  /** Total do item (R$) = Qtde a comprar x custo da pré-compra; vazio quando não há custo. */
  totalItemPedido(l: { qtdeOrigem?: number; custoPedidoBrl?: number }): number | null {
    return l.custoPedidoBrl && l.qtdeOrigem ? parseFloat((l.custoPedidoBrl * l.qtdeOrigem).toFixed(2)) : null;
  }

  /**
   * Item vindo de Pré-Compra: o preço é o CUSTO da própria pré-compra. Importação: U$ = custo R$ ÷ cotação
   * da pré-compra, R$ = U$ × dólar do dia. Nacional: o custo R$ é o valor unitário e o U$ sai do dólar do dia.
   */
  private _aplicarCustoDaPreCompra(item: ItemCompra): void {
    const custo = item.custoPedidoBrl ?? 0;
    if (!item.origemItem || custo <= 0) return;
    const taxa = this.cotacaoValorNumerico;
    // O valor unitário R$ é EXATAMENTE o do pedido de origem (sem arredondar); o U$ é derivado com até 4 casas.
    item.precoUnitario = custo;
    if (item.pedidoNacional) {
      item.precoUsd = taxa > 0 ? parseFloat((custo / taxa).toFixed(4)) : 0;
    } else {
      const cotPed = item.cotacaoPedido ?? 0;
      const usd = cotPed > 0 ? custo / cotPed : (taxa > 0 ? custo / taxa : 0);
      item.precoUsd = parseFloat(usd.toFixed(4));
    }
    item.precoUsdStr = item.precoUsd > 0 ? this.fmtDecimal(item.precoUsd) : '';
    this._calcularTotal(item);
  }

  async confirmarDescoberta(): Promise<void> {
    // Guarda contra clique duplo -- o [disabled] no botão já cobre o caso
    // normal, mas esse "return" aqui garante que nem um clique bem rápido
    // (2 cliques antes do Angular repintar o botão como desabilitado)
    // dispare a importação duas vezes.
    if (this.descobertaImportando) return;

    const marcados = this.descobertaItens.filter(i => i.marcado);
    if (marcados.length === 0) { this.fecharDescoberta(); return; }

    this.descobertaImportando = true;
    try {
      // Remove linha em branco antes de adicionar -- mesmo padrão do Importar Excel.
      this.itens = this.itens.filter(i => !!(i.codprod || i.descricao || i.codprodInterno));

      // Monta as linhas DIRETO com o que já veio da busca de descoberta
      // (codProd/pn/descricao/unidade/codLocalPadrao, tudo em 1 chamada só
      // quando o modal abriu) -- SEM fazer uma busca de produto por PN pra
      // cada item marcado, como fazia antes. Com milhares de itens marcados
      // de uma vez, 1 requisição por item era o gargalo real da lentidão.
      const novos: ItemCompra[] = marcados.map(linha => {
        const novo = this._novoItem();
        novo.codprod         = linha.pn;
        novo.quantidade      = 1;
        novo.descricao       = linha.descricao ?? '';
        novo.codprodOriginal = linha.pn;
        novo.unidade         = linha.unidade ?? 'UN';
        novo.codprodInterno  = linha.codProd || undefined;
        novo.codlocalpadrao  = linha.codLocalPadrao ?? 0;
        // Item vindo da Pré-Compra: segue com o local dela (já é de uma empresa real).
        if (linha.codLocalOrigem) novo.localSel = linha.codLocalOrigem;
        // Item de Pré-Compra: já vem com a quantidade pendente da pré-compra (editável pra faturar parcial).
        if (linha.qtdeOrigem) novo.quantidade = linha.qtdeOrigem;
        novo.origemItem      = linha.origemItem;
        novo.headerIdOrigem  = linha.headerIdOrigem;
        novo.seqOrigem       = linha.seqOrigem;
        novo.custoPedidoBrl  = linha.custoPedidoBrl;
        novo.cotacaoPedido   = linha.cotacaoPedido;
        novo.pedidoNacional  = linha.pedidoNacional;
        novo.pciId           = linha.pciId;
        novo.pcpId           = linha.pcpId;
        return novo;
      });
      this.itens.push(...novos);

      // Preço/estoque ainda dependem de 1 chamada por item (não existe
      // endpoint em lote no Sankhya pra isso) -- roda em lotes em paralelo,
      // em vez de 1 por vez (lento) ou todos de uma vez só (sobrecarrega o
      // gateway do Sankhya com milhares de chamadas simultâneas). O
      // descobertaProgressoFeito/Total dá feedback visual no modal --
      // listas grandes demoram mesmo (não tem endpoint em lote no Sankhya),
      // mas assim o usuário vê que está avançando, não travado.
      this.descobertaProgressoFeito = 0;
      this.descobertaProgressoTotal = novos.length;
      await this._executarEmLotes(novos, 10, async item => {
        await this._carregarPrecoEstoqueItem(item);
        this._aplicarCustoDaPreCompra(item);
        this.descobertaProgressoFeito++;
      });

      this.onFiltroQtdeVendidaMudou();
    } finally {
      this.descobertaImportando = false;
      this.descobertaProgressoFeito = 0;
      this.descobertaProgressoTotal = 0;
      this.fecharDescoberta();
    }
  }

  /** Roda `tarefa` pra cada item de `itens`, no máximo `limite` promessas
   *  simultâneas por vez -- meio-termo entre sequencial (lento com listas
   *  grandes) e Promise.all irrestrito (sobrecarrega o servidor quando são
   *  milhares de itens de uma vez). Uma falha isolada não trava o lote --
   *  e cada chamada individual (buscarPrecoExc/buscarEstoquePorLocal) já
   *  tem timeout próprio, então um item que trava não segura o lote inteiro
   *  pra sempre. */
  private async _executarEmLotes<T>(itens: T[], limite: number, tarefa: (item: T) => Promise<void>): Promise<void> {
    for (let i = 0; i < itens.length; i += limite) {
      const lote = itens.slice(i, i + limite);
      await Promise.all(lote.map(item => tarefa(item).catch(() => {})));
    }
  }

  // ── Importação de Excel ─────────────────────────────────────
  excelImportAberto       = false;
  excelImportLinhas: ExcelImportRow[] = [];
  excelImportValidando    = false;
  excelImportando         = false;
  excelImportNomeArquivo  = '';
  excelAproximadosLinha: ExcelImportRow | null = null;
  excelAvisoNaoEncontrado = false;
  excelMapeamentoAberto   = false;
  excelColunas: string[]  = [];
  excelColunaPn: number | null = null;
  excelColunaQty: number | null = null;
  excelRowsRaw: any[][]   = [];
  excelPreviewLinhas: any[][] = [];

  abrirSeletorExcel(): void {
    const input = document.getElementById('pcf-excel-input') as HTMLInputElement;
    if (input) { input.value = ''; input.click(); }
  }

  /** Exporta os itens do pedido atual pra uma planilha .xlsx -- mesmo
   *  padrão do Pedido de Venda (exportarItensExcel lá): usa os nomes de
   *  coluna "PN" e "Quantidade" que o próprio Importar Itens já reconhece
   *  automaticamente (ver _detectarColunas acima), então um arquivo
   *  exportado daqui pode ser reimportado depois sem mapeamento manual. */
  exportarItensExcel(): void {
    const itensValidos = this.itens.filter(i => i.codprodInterno && i.codprodInterno > 0);
    if (itensValidos.length === 0) {
      this.abrirAlerta('Não há itens na compra para exportar.', 'aviso');
      return;
    }

    const linhas = itensValidos.map(i => ({
      'PN':            i.codprod,
      'Descrição':     i.descricao,
      'UN':            i.unidade,
      'Quantidade':    i.quantidade,
      'Vl. Unit. U$':  i.precoUsd,
      'Vl. Unit. R$':  i.precoUnitario,
      'Custo U$':      i.custoAnalitico ?? '',
      'Total R$':      i.total,
    }));

    const ws = XLSX.utils.json_to_sheet(linhas);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Itens');
    const sufixo = this.nunotaAtual ? `_${this.nunotaAtual}` : '';
    XLSX.writeFile(wb, `Itens_Compra${sufixo}.xlsx`);
  }

  private _detectarColunas(headerRow: any[]): { colPn: number; colQty: number } {
    const norm = (s: any) => String(s ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    const aliasesPn  = new Set(['PN','PART','PARTNUMBER','PARTNUMBERS','PARTNO',
      'CODIGO','CÓDIGO','COD','REF','REFERENCIA','REFERÊNCIA','REFFORN','ITEM',
      'NUMEROPECA','NUMERODEPEÇA','CODPROD','PRODUTO']);
    const aliasesQty = new Set(['QUANTIDADE','QUANT','QTD','QTY','QTDE','QNT',
      'QUANTITY','QT','QDE','QTDE.','QUANT.']);
    let colPn = -1, colQty = -1;
    for (let i = 0; i < headerRow.length; i++) {
      const n = norm(headerRow[i]);
      if (colPn  === -1 && aliasesPn.has(n))  colPn  = i;
      if (colQty === -1 && aliasesQty.has(n)) colQty = i;
    }
    return { colPn, colQty };
  }

  private _parsearLinhasExcel(rows: any[][], colPn: number, colQty: number, startRow: number): ExcelImportRow[] {
    const linhas: ExcelImportRow[] = [];
    for (let i = startRow; i < rows.length; i++) {
      const row = rows[i];
      const pnRaw = String(row[colPn] ?? '').trim();
      if (!pnRaw) continue;
      const qty = Number(row[colQty]);
      linhas.push({ pn: pnRaw, quantidade: isNaN(qty) || qty <= 0 ? 1 : qty, status: 'pendente' });
    }
    return linhas;
  }

  async onExcelSelecionado(event: Event): Promise<void> {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;

    this.excelImportNomeArquivo = file.name;
    this.excelImportLinhas     = [];
    this.excelImportAberto     = true;
    this.excelImportValidando  = true;
    this.excelMapeamentoAberto = false;

    try {
      const data = await file.arrayBuffer();
      const wb   = XLSX.read(data, { type: 'array' });
      const ws   = wb.Sheets[wb.SheetNames[0]];
      const rows: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' });

      if (rows.length === 0) return;

      const { colPn, colQty } = this._detectarColunas(rows[0]);
      if (colPn !== -1 && colQty !== -1) {
        this.excelImportLinhas = this._parsearLinhasExcel(rows, colPn, colQty, 1);
        await this._validarPNsExcel();
      } else {
        this.excelRowsRaw       = rows;
        this.excelColunas       = rows[0].map((c: any, i: number) => {
          const label = String(c ?? '').trim();
          return label || `Coluna ${i + 1}`;
        });
        this.excelPreviewLinhas = rows.slice(1, 6);
        this.excelColunaPn      = null;
        this.excelColunaQty     = null;
        this.excelMapeamentoAberto = true;
      }
    } catch (e) {
      console.error('Erro ao ler Excel:', e);
      this.excelImportLinhas = [];
    } finally {
      this.excelImportValidando = false;
    }
  }

  async confirmarMapeamento(): Promise<void> {
    if (this.excelColunaPn === null || this.excelColunaQty === null) return;
    this.excelMapeamentoAberto = false;
    this.excelImportValidando  = true;
    try {
      this.excelImportLinhas = this._parsearLinhasExcel(
        this.excelRowsRaw, this.excelColunaPn, this.excelColunaQty, 1
      );
      await this._validarPNsExcel();
    } catch {
      this.excelImportLinhas = [];
    } finally {
      this.excelImportValidando = false;
    }
  }

  private async _validarPNsExcel(): Promise<void> {
    const normalizar = (s: string) => (s ?? '').toUpperCase().replace(/[.\-\/\s]/g, '');
    for (const linha of this.excelImportLinhas) {
      try {
        const res: any = await firstValueFrom(
          this.gateway.buscarProdutosEdicao({ REFFORN: linha.pn })
        );
        const lista: any[] = (res?.responseBody ?? res)?.lista ?? [];
        if (lista.length > 0) {
          const pnNorm = normalizar(linha.pn);
          const exato  = lista.find((p: any) => normalizar(p.refforn ?? '') === pnNorm);
          if (exato) {
            linha.status         = 'encontrado';
            linha.descricao      = exato.descricao ?? '';
            linha.codprodInterno = Number(exato.codprod ?? 0) || undefined;
            linha.codlocalpadrao = Number(exato.codlocalpadrao ?? 0) || 0;
            linha.prodData       = exato;
          } else {
            linha.status       = 'nao_encontrado';
            linha.proximosData = lista.slice(0, 8);
          }
        } else {
          linha.status = 'nao_encontrado';
        }
      } catch {
        linha.status = 'nao_encontrado';
      }
    }
  }

  toggleAproximados(linha: ExcelImportRow): void {
    this.excelAproximadosLinha = this.excelAproximadosLinha === linha ? null : linha;
  }

  selecionarAproximado(linha: ExcelImportRow, prod: any): void {
    linha.pn             = prod.refforn ?? linha.pn;
    linha.status         = 'encontrado';
    linha.descricao      = prod.descricao ?? '';
    linha.codprodInterno = Number(prod.codprod ?? 0) || undefined;
    linha.codlocalpadrao = Number(prod.codlocalpadrao ?? 0) || 0;
    linha.prodData       = prod;
    linha.proximosData   = undefined;
    this.excelAproximadosLinha = null;
  }

  get excelImportEncontrados(): number {
    return this.excelImportLinhas.filter(l => l.status === 'encontrado').length;
  }

  get excelImportNaoEncontrados(): number {
    return this.excelImportLinhas.filter(l => l.status === 'nao_encontrado').length;
  }

  async confirmarImportacaoExcel(): Promise<void> {
    if (this.excelImportNaoEncontrados > 0 && !this.excelAvisoNaoEncontrado) {
      this.excelAvisoNaoEncontrado = true;
      return;
    }
    this.excelAvisoNaoEncontrado = false;
    this.excelImportando = true;
    try {
      // PNs não encontrados → adiciona à observação
      const naoEncontrados = this.excelImportLinhas.filter(l => l.status === 'nao_encontrado');
      if (naoEncontrados.length > 0) {
        const bloco = `PNs não encontrados:\n${naoEncontrados.map(l => `${l.pn} - Qtd: ${l.quantidade}`).join('\n')}`;
        this.observacao = this.observacao ? `${this.observacao}\n${bloco}` : bloco;
      }
      // Remove linhas em branco e adiciona os itens encontrados
      this.itens = this.itens.filter(i => !!(i.codprod || i.descricao || i.codprodInterno));
      const encontrados = this.excelImportLinhas.filter(l => l.status === 'encontrado');
      const carregamentos: Promise<void>[] = [];
      for (const linha of encontrados) {
        const novo = this._novoItem();
        novo.codprod    = linha.pn;
        novo.quantidade = linha.quantidade;
        this.itens.push(novo);
        if (linha.prodData) {
          const p = linha.prodData;
          novo.descricao        = p.descricao ?? '';
          novo.codprodOriginal  = linha.pn;
          novo.unidade          = p.codvol ?? 'UN';
          novo.codprodInterno   = Number(p.codprod ?? 0) || undefined;
          novo.codlocalpadrao   = Number(p.codlocalpadrao ?? 0) || 0;
          carregamentos.push(this._buscarPrecoItem(novo));
        }
      }
      await Promise.all(carregamentos);
      this.onFiltroQtdeVendidaMudou();
    } finally {
      this.excelImportando  = false;
      this.excelImportAberto = false;
      this.excelImportLinhas = [];
    }
  }

  cancelarAvisoExcel(): void { this.excelAvisoNaoEncontrado = false; }

  fecharImportacaoExcel(): void {
    this.excelImportAberto     = false;
    this.excelImportLinhas     = [];
    this.excelAvisoNaoEncontrado = false;
    this.excelMapeamentoAberto = false;
    this.excelRowsRaw          = [];
    this.excelColunas          = [];
    this.excelPreviewLinhas    = [];
    this.excelColunaPn         = null;
    this.excelColunaQty        = null;
  }

  // ── Busca de Peças (F3 / Enter) ─────────────────────────────
  buscaPecasAberta        = false;
  buscaPecasTermo         = '';
  buscaPecasResultados: any[] = [];
  buscaPecasCarregando    = false;
  buscaPecasSemResultado  = false;
  buscaPecasProdutoSelecionado: any | null = null;
  buscaPecasLocais: { codLocal: number; codemp: number; nomeEmp: string; descrLocal: string; qtdTotal: number; qtdReservada: number; disponivel: number }[] = [];
  buscaPecasLocaisCarregando = false;
  private _buscaPecasItem: ItemCompra | null = null;
  private _buscaPecasSubject = new Subject<string>();

  // ── Produtos Alternativos (TGFPAL) — mesma lógica da Venda, sem preço ──────
  buscaPecasProdutoExpandido: any | null = null;
  buscaPecasAlternativos: any[] = [];
  buscaPecasAlternativosCarregando = false;

  // ── Ordenação da tabela de resultados (Busca de Peças / F3) — mesma da Venda ──
  buscaPecasOrdenarCampo: string | null = null;
  buscaPecasOrdemAsc = true;

  // ── Filtro por coluna (em tela, sobre os resultados já carregados) — mesma da Venda ──
  filtrosBusca: { [campo: string]: string } = {};
  colunaFiltroAberta: string | null = null;

  // Imagem do produto selecionado (painel lateral direito) + preview ampliado
  // — mesmo padrão do Pedido de Venda (F3), reaproveitando o mesmo endpoint
  // ProdutoGlobalSP.doBuscarImg já usado na Edição de Produtos.
  buscaPecasImagemUrl: string | null = null;
  buscaPecasImagemCarregando = false;
  private _buscaPecasImagemToken = 0;
  // Todas as imagens do produto (principal do TGFPRO + histórico do GPL_PRODUTOSIMG),
  // usadas para montar a faixa de miniaturas e navegar no preview ampliado.
  buscaPecasImagensExtras: string[] = [];
  buscaPecasImagemIndexAtivo = 0;
  imagemPreviewAberta = false;

  private _carregarImagemProdutoDetalhe(codprod: number): void {
    this.buscaPecasImagemUrl = null;
    this.buscaPecasImagensExtras = [];
    this.buscaPecasImagemIndexAtivo = 0;
    if (!codprod) { this.buscaPecasImagemCarregando = false; return; }
    this.buscaPecasImagemCarregando = true;
    const token = ++this._buscaPecasImagemToken;
    this.gateway.buscarImgProdutoEdicao({CODPROD: codprod}).subscribe({
      next: (res: any) => {
        if (token !== this._buscaPecasImagemToken) return;
        const body = res?.responseBody ?? res;
        const imagens: string[] = [];
        if (body?.principal) {
          imagens.push(`data:image/jpeg;base64,${body.principal}`);
        }
        for (const img of (body?.lista ?? [])) {
          if (img?.imagem) imagens.push(`data:image/jpeg;base64,${img.imagem}`);
        }
        this.buscaPecasImagensExtras = imagens;
        this.buscaPecasImagemIndexAtivo = 0;
        this.buscaPecasImagemUrl = imagens.length > 0 ? imagens[0] : null;
        this.buscaPecasImagemCarregando = false;
      },
      error: () => {
        if (token !== this._buscaPecasImagemToken) return;
        this.buscaPecasImagemUrl = null;
        this.buscaPecasImagensExtras = [];
        this.buscaPecasImagemIndexAtivo = 0;
        this.buscaPecasImagemCarregando = false;
      }
    });
  }

  abrirPreviewImagemBusca(): void {
    if (!this.buscaPecasImagemUrl) return;
    this.imagemPreviewAberta = true;
  }

  fecharPreviewImagemBusca(): void {
    this.imagemPreviewAberta = false;
  }

  /** Setas ←/→ navegam entre as imagens do produto quando o preview ampliado está aberto. */
  @HostListener('document:keydown.arrowleft')
  onArrowLeftImagemPreview(): void {
    if (this.imagemPreviewAberta) this.imagemPreviewNavegar(-1);
  }

  @HostListener('document:keydown.arrowright')
  onArrowRightImagemPreview(): void {
    if (this.imagemPreviewAberta) this.imagemPreviewNavegar(1);
  }

  /** Troca a imagem em destaque (painel lateral e preview ampliado) pela de índice `index`. */
  selecionarImagemBusca(index: number): void {
    if (index < 0 || index >= this.buscaPecasImagensExtras.length) return;
    this.buscaPecasImagemIndexAtivo = index;
    this.buscaPecasImagemUrl = this.buscaPecasImagensExtras[index];
  }

  /** Navega pra imagem anterior/próxima dentro do preview ampliado (quando há mais de uma). */
  imagemPreviewNavegar(passo: 1 | -1, event?: Event): void {
    event?.stopPropagation();
    const total = this.buscaPecasImagensExtras.length;
    if (total < 2) return;
    const novo = (this.buscaPecasImagemIndexAtivo + passo + total) % total;
    this.selecionarImagemBusca(novo);
  }

  /** Reseta o estado do modal de Busca de Peças e abre com o termo indicado
   *  (vazio = modal em branco). Fatorado de abrirBuscaPecas() pra ser
   *  reaproveitado também pelo preenchimento automático (buscarProdutoPorPN). */
  private _abrirModalBusca(item: ItemCompra, termoInicial: string): void {
    this._buscaPecasItem              = item;
    this.buscaPecasTermo              = termoInicial;
    this.buscaPecasResultados         = [];
    this.buscaPecasSemResultado       = false;
    this.buscaPecasProdutoSelecionado = null;
    this.buscaPecasLocais             = [];
    this.buscaPecasImagemUrl          = null;
    this.buscaPecasImagensExtras      = [];
    this.buscaPecasImagemIndexAtivo    = 0;
    this.imagemPreviewAberta          = false;
    this.buscaPecasProdutoExpandido       = null;
    this.buscaPecasAlternativos           = [];
    this.buscaPecasAlternativosCarregando = false;
    this.filtrosBusca                     = {};
    this.colunaFiltroAberta               = null;
    this.buscaPecasOrdenarCampo           = null;
    this.buscaPecasOrdemAsc               = true;
    this.buscaPecasAberta             = true;

    this._buscaPecasSubject.pipe(debounceTime(350), distinctUntilChanged())
      .subscribe(termo => this._executarBuscaPecas(termo));
  }

  /**
   * Enter ou F3 no campo PN. F3 sempre abre o modal de busca (mesmo padrão
   * do Pedido de Venda). Enter com PN digitado e produto ainda não
   * carregado tenta preencher DIRETO (buscarProdutoPorPN) -- só cai pro
   * modal se não achar exato ou achar mais de um -- pedido do usuário pra
   * não precisar abrir o F3 pra cada peça digitada.
   */
  abrirBuscaPecas(item: ItemCompra, event: Event): void {
    event.preventDefault();
    const pn   = (item.codprod ?? '').trim();
    const isF3 = (event as KeyboardEvent).key === 'F3';

    if (isF3) {
      this._abrirModalBusca(item, pn);
      setTimeout(() => {
        document.querySelector<HTMLInputElement>('.busca-pecas-input-unico')?.focus();
        if (pn) this._executarBuscaPecas(pn);
      }, 60);
      return;
    }

    // PN digitado diferente do carregado: refaz a consulta com o novo PN
    if (this._pnFoiAlterado(item)) {
      this._limparProdutoParaNovaBusca(item);
      this.buscarProdutoPorPN(item, event);
      return;
    }

    // Se o produto já está preenchido → foca QTD da mesma linha
    if (item.codprodInterno) {
      const idx = this.itens.indexOf(item);
      setTimeout(() => {
        const rows = document.querySelectorAll<HTMLElement>('.pcf-itens-table tbody tr');
        const qtd  = rows[idx]?.querySelector<HTMLInputElement>('.pcf-cell-qtd');
        qtd?.focus(); qtd?.select();
      }, 60);
      return;
    }

    // Enter com PN digitado e produto ainda não carregado → busca e preenche direto
    if (pn) {
      this.buscarProdutoPorPN(item, event);
      return;
    }

    // Enter vazio → abre modal de busca em branco
    this._abrirModalBusca(item, '');
    setTimeout(() => document.querySelector<HTMLInputElement>('.busca-pecas-input-unico')?.focus(), 60);
  }

  /**
   * Busca automática ao digitar o PN e sair do campo (Enter ou blur) --
   * igual ao Pedido de Venda (buscarProdutoPorPN lá), pedido do usuário
   * pra não precisar mais abrir o F3 pra cada peça. Só cai pro modal
   * quando: PN não encontrado (abre já com o termo buscado), ou há mais de
   * um resultado sem match exato (abre com os resultados já prontos, sem
   * buscar de novo, pro usuário escolher).
   */
  /** Produto já carregado mas o PN foi alterado no campo: limpa a linha (mantém a quantidade) para refazer a consulta. */
  private _pnFoiAlterado(item: ItemCompra): boolean {
    const pn = (item.codprod ?? '').trim();
    return !!item.codprodInterno && !!pn && !!item.codprodOriginal && pn !== item.codprodOriginal.trim();
  }

  private _limparProdutoParaNovaBusca(item: ItemCompra): void {
    const pn = item.codprod;
    const qtd = item.quantidade;
    const novo = this._novoItem();
    for (const k of Object.keys(item)) {
      if (k !== 'id') delete (item as any)[k];
    }
    Object.assign(item, novo, { id: item.id, codprod: pn, quantidade: qtd || 1 });
  }

  async buscarProdutoPorPN(item: ItemCompra, event: Event): Promise<void> {
    event.preventDefault();
    const pn = (item.codprod ?? '').trim();
    if (!pn) return;

    // Trava de reentrância -- mesmo motivo do Pedido de Venda: desabilitar
    // o campo com foco (via [disabled]="!!item.buscando" no template)
    // dispara um blur automático, que chamaria onPnBlur -> essa mesma
    // busca de novo, em paralelo com a primeira.
    if (item.buscando) return;

    item.buscando = true;
    try {
      const codemp = Number(this.empresaState.codEmpReal) || undefined;
      const res: any = await firstValueFrom(this.gateway.buscarPecasModal({ REFFORN: pn, CODEMP: codemp }));
      const lista: any[] = (res?.responseBody ?? res)?.lista ?? [];

      if (lista.length === 0) {
        // PN não encontrado → abre modal com o termo pré-preenchido e busca disparada
        this._abrirModalBusca(item, pn);
        setTimeout(() => {
          document.querySelector<HTMLInputElement>('.busca-pecas-input-unico')?.focus();
          this._executarBuscaPecas(pn);
        }, 60);
        return;
      }

      if (lista.length > 1) {
        // Mais de um produto — verifica se algum é match exato do PN digitado
        // (mesma normalização usada na busca em si -- ver normalizarPn() no addon GPL).
        const normalizar = (s: string) => (s ?? '').toUpperCase().replace(/[.\-\/\s]/g, '');
        const pnNorm = normalizar(pn);
        const exatos = lista.filter((p: any) => normalizar(p.refforn ?? '') === pnNorm);
        if (exatos.length === 1) {
          this._selecionarProdutoDireto(item, exatos[0]);
          return;
        }
        // Zero exatos (só parecidos) ou múltiplos com o mesmo PN → abre modal
        // já com os resultados prontos (exatos primeiro), sem buscar de novo.
        lista.sort((a: any, b: any) => {
          const aExato = normalizar(a.refforn) === pnNorm ? 0 : 1;
          const bExato = normalizar(b.refforn) === pnNorm ? 0 : 1;
          return aExato - bExato;
        });
        this._abrirModalBusca(item, pn);
        this.buscaPecasResultados = lista;
        setTimeout(() => document.querySelector<HTMLInputElement>('.busca-pecas-input-unico')?.focus(), 60);
        return;
      }

      this._selecionarProdutoDireto(item, lista[0]);
    } catch (err) {
      console.error('[Compra] erro ao buscar produto por PN:', err);
      this.abrirAlerta('Erro ao buscar produto.', 'erro');
    } finally {
      item.buscando = false;
    }
  }

  /** Preenche o item direto com o produto achado, sem passar pelo modal --
   *  mesmo preenchimento usado ao confirmar manualmente no F3
   *  (_preencherItem), só ajustando o PN pro formato exato vindo do banco
   *  antes (com traços/pontuação certos, igual confirmarSelecaoPeca). */
  private _selecionarProdutoDireto(item: ItemCompra, prod: any): void {
    item.codprod = prod.refforn ?? prod.referencia ?? String(prod.codprod ?? '');
    this._preencherItem(item, prod);
  }

  onBuscaPecasInput(): void {
    this._buscaPecasSubject.next(this.buscaPecasTermo);
  }

  private async _executarBuscaPecas(termo: string): Promise<void> {
    const t = termo.trim();
    if (t.length < 2) {
      this.buscaPecasResultados         = [];
      this.buscaPecasSemResultado       = false;
      this.buscaPecasProdutoSelecionado = null;
      this.buscaPecasLocais             = [];
      this.buscaPecasImagemUrl          = null;
      this.buscaPecasImagensExtras      = [];
      this.buscaPecasImagemIndexAtivo    = 0;
      this.buscaPecasProdutoExpandido   = null;
      return;
    }
    this.buscaPecasCarregando         = true;
    this.buscaPecasSemResultado       = false;
    this.buscaPecasProdutoSelecionado = null;
    this.buscaPecasLocais             = [];
    this.buscaPecasImagemUrl          = null;
    this.buscaPecasImagensExtras      = [];
    this.buscaPecasImagemIndexAtivo    = 0;
    this.buscaPecasProdutoExpandido   = null;
    this.filtrosBusca                 = {}; // nova busca zera filtros de coluna anteriores
    try {
      const codemp = Number(this.empresaState.codEmpReal) || undefined;
      // 1ª tentativa por PN
      const resPN: any = await firstValueFrom(this.gateway.buscarPecasModal({ REFFORN: t, CODEMP: codemp }));
      const listaPN: any[] = (resPN?.responseBody ?? resPN)?.lista ?? [];
      if (listaPN.length > 0) {
        this.buscaPecasResultados   = listaPN;
        this.buscaPecasSemResultado = false;
        // O primeiro resultado já vem selecionado (estoque, imagem e alternativos carregam sozinhos).
        this.selecionarProdutoParaDetalhe(listaPN[0]);
        return;
      }
      // 2ª tentativa por descrição
      const resDesc: any = await firstValueFrom(this.gateway.buscarPecasModal({ DESCRICAO: t, CODEMP: codemp }));
      const listaDesc: any[] = (resDesc?.responseBody ?? resDesc)?.lista ?? [];
      this.buscaPecasResultados   = listaDesc;
      this.buscaPecasSemResultado = listaDesc.length === 0;
      if (listaDesc.length > 0) this.selecionarProdutoParaDetalhe(listaDesc[0]);
    } catch {
      this.buscaPecasSemResultado = true;
    } finally {
      this.buscaPecasCarregando = false;
    }
  }

  async selecionarProdutoParaDetalhe(prod: any): Promise<void> {
    // Guarda: um duplo-clique dispara click, click, dblclick em sequência no navegador.
    // Sem esta guarda, este método reseta e refaz o fetch duas vezes antes do dblclique
    // ser processado, causando a "tela tremendo" durante o duplo-clique (mesmo fix da Venda).
    if (this.buscaPecasProdutoSelecionado === prod) return;

    this.buscaPecasProdutoSelecionado = prod;
    // Fixa o produto principal expandido — a sub-lista de alternativos usa este
    // campo (não buscaPecasProdutoSelecionado) para permanecer visível mesmo
    // quando o usuário depois clica em um dos alternativos abaixo.
    this.buscaPecasProdutoExpandido       = prod;
    this.buscaPecasLocais                 = [];
    this.buscaPecasLocaisCarregando       = true;
    this.buscaPecasAlternativos           = [];
    this.buscaPecasAlternativosCarregando = true;
    const codprodImg = Number(prod.codprod);
    this._carregarImagemProdutoDetalhe(codprodImg);
    const codprod = Number(prod.codprod);
    if (!codprod) {
      this.buscaPecasLocaisCarregando       = false;
      this.buscaPecasAlternativosCarregando = false;
      return;
    }
    try {
      const res: any = await firstValueFrom(this.gateway.buscarEstoquePorLocal(codprod));
      const todos: any[] = (res?.responseBody ?? res)?.locais ?? [];
      this.buscaPecasLocais = todos.filter(
        l => (l.qtdTotal ?? 0) !== 0 || (l.qtdReservada ?? 0) !== 0 || (l.disponivel ?? 0) !== 0
      );
    } catch { }
    finally { this.buscaPecasLocaisCarregando = false; }

    // Alternativos TGFPAL (fire-and-forget) -- mesma chamada genérica da Venda.
    const codEmpAlt = Number(this.empresaState.codEmpReal) || undefined;
    this.gateway.buscarAlternativosProduto(codprod, codEmpAlt).subscribe({
      next: (res: any) => {
        const body = res?.responseBody ?? res;
        this.buscaPecasAlternativos           = body?.lista ?? [];
        this.buscaPecasAlternativosCarregando = false;
      },
      error: () => { this.buscaPecasAlternativosCarregando = false; }
    });
  }

  /** Clique em um dos alternativos da sub-lista — mostra estoque/imagem dele, mas
   *  mantém a sub-lista de alternativos do produto PRINCIPAL visível (não usa
   *  buscaPecasProdutoExpandido, que continua apontando pro item de cima). */
  async selecionarAlternativoParaDetalhe(alt: any): Promise<void> {
    if (this.buscaPecasProdutoSelecionado === alt) return;
    this.buscaPecasProdutoSelecionado = alt;
    this.buscaPecasLocais             = [];
    this.buscaPecasLocaisCarregando   = true;
    const codprod = Number(alt.codprod);
    this._carregarImagemProdutoDetalhe(codprod);
    if (!codprod) { this.buscaPecasLocaisCarregando = false; return; }
    try {
      const res: any = await firstValueFrom(this.gateway.buscarEstoquePorLocal(codprod));
      const todos: any[] = (res?.responseBody ?? res)?.locais ?? [];
      this.buscaPecasLocais = todos.filter(
        l => (l.qtdTotal ?? 0) !== 0 || (l.qtdReservada ?? 0) !== 0 || (l.disponivel ?? 0) !== 0
      );
    } catch { }
    finally { this.buscaPecasLocaisCarregando = false; }
  }

  // ── Valores de venda (R$/U$ + IPI) na Busca de Peças — mesma lógica da Venda ──

  /**
   * Converte Valor Moeda → Valor R$ na tela de Busca de Peças (F3), principal
   * e alternativos. Sempre multiplica pela cotação do dia.
   */
  valorEmReaisBusca(vlrVenda: number | null | undefined, _origemNacional: boolean | null | undefined, cotacao: number): number | null {
    if (vlrVenda == null) return null;
    return cotacao > 0 ? vlrVenda * cotacao : null;
  }

  /** Valor unitário do IPI (R$) do produto na Busca de Peças — preço R$ × alíquota IPI
   *  (a alíquota já vem no resultado da busca, via JOIN com TGFIPI no backend). */
  vlrIpiUnitarioBusca(p: any, cotacao: number): number {
    const precoBrl = this.valorEmReaisBusca(p?.vlrVenda, p?.origemNacional, cotacao);
    const aliq = parseFloat(String(p?.aliqIpi ?? p?.aliq_ipi ?? '0').replace(',', '.')) || 0;
    return precoBrl != null && aliq > 0 ? parseFloat((precoBrl * aliq / 100).toFixed(2)) : 0;
  }

  /** Custo de reposição (R$) do produto na Busca de Peças (TGFCUS.CUSREP). */
  custoReaisBusca(p: any): number | null {
    const c = Number(p?.custo);
    return c > 0 ? parseFloat(c.toFixed(2)) : null;
  }

  /** Custo convertido pra U$ pela cotação selecionada. */
  custoMoedaBusca(p: any, cotacao: number): number | null {
    const c = Number(p?.custo);
    return c > 0 && cotacao > 0 ? parseFloat((c / cotacao).toFixed(2)) : null;
  }

  /** Valor Moeda (U$) já somado o IPI unitário (IPI é sempre em R$, convertido pela cotação). */
  valorMoedaComIpiBusca(p: any, cotacao: number): number | null {
    if (p?.vlrVenda == null) return null;
    const ipiUsd = cotacao > 0 ? this.vlrIpiUnitarioBusca(p, cotacao) / cotacao : 0;
    return parseFloat((p.vlrVenda + ipiUsd).toFixed(2));
  }

  /** Valor R$ já somado o IPI unitário. */
  valorReaisComIpiBusca(p: any, cotacao: number): number | null {
    const precoBrl = this.valorEmReaisBusca(p?.vlrVenda, p?.origemNacional, cotacao);
    if (precoBrl == null) return null;
    return parseFloat((precoBrl + this.vlrIpiUnitarioBusca(p, cotacao)).toFixed(2));
  }

  /** Converte "dd/MM/yyyy" num número comparável (yyyyMMdd) pra ordenar por data
   *  sem depender de new Date(str), que é ambíguo entre browsers/locales. */
  private _dataBrParaOrdenacao(dataBr: string | null | undefined): number | null {
    if (!dataBr) return null;
    const partes = dataBr.split('/');
    if (partes.length !== 3) return null;
    const dd = parseInt(partes[0], 10), mm = parseInt(partes[1], 10), yyyy = parseInt(partes[2], 10);
    if (!dd || !mm || !yyyy) return null;
    return yyyy * 10000 + mm * 100 + dd;
  }

  // ── Filtro/ordenação por coluna (mesma lógica da Venda) ──

  /** Resultados exibidos na tabela: buscaPecasResultados após aplicar os
   *  filtros de coluna ativos em filtrosBusca. Não muta buscaPecasResultados
   *  (a ordenação continua funcionando normalmente sobre a lista completa). */
  get buscaPecasResultadosExibidos(): any[] {
    const campos = Object.keys(this.filtrosBusca).filter(c => (this.filtrosBusca[c] || '').trim().length > 0);
    if (campos.length === 0) return this.buscaPecasResultados;
    return this.buscaPecasResultados.filter(p => campos.every(campo => {
      const termo = this.filtrosBusca[campo].trim().toLowerCase();
      const valor = this._valorOrdenacaoBusca(p, campo);
      return String(valor ?? '').toLowerCase().includes(termo);
    }));
  }

  limparFiltroBusca(campo: string, event?: Event): void {
    event?.stopPropagation();
    delete this.filtrosBusca[campo];
  }

  temFiltroBusca(campo: string): boolean {
    return !!(this.filtrosBusca[campo] || '').trim();
  }

  toggleFiltroBusca(campo: string, event?: Event): void {
    event?.stopPropagation();
    this.colunaFiltroAberta = this.colunaFiltroAberta === campo ? null : campo;
    if (this.colunaFiltroAberta === campo) {
      setTimeout(() => document.getElementById('filtro-busca-compra-' + campo)?.focus(), 0);
    }
  }

  /** Fecha o campo de digitação ao perder o foco/Enter — o filtro
   *  continua aplicado normalmente, só o input inline é que recolhe. */
  fecharFiltroBusca(): void {
    this.colunaFiltroAberta = null;
  }

  ordenarBuscaPecas(campo: string): void {
    if (this.buscaPecasOrdenarCampo === campo) {
      this.buscaPecasOrdemAsc = !this.buscaPecasOrdemAsc;
    } else {
      this.buscaPecasOrdenarCampo = campo;
      this.buscaPecasOrdemAsc = true;
    }
    const dir = this.buscaPecasOrdemAsc ? 1 : -1;
    this.buscaPecasResultados = [...this.buscaPecasResultados].sort((a, b) => {
      const va = this._valorOrdenacaoBusca(a, campo);
      const vb = this._valorOrdenacaoBusca(b, campo);
      if (va == null && vb == null) return 0;
      if (va == null) return 1;  // sem valor sempre por último, nas duas direções
      if (vb == null) return -1;
      if (typeof va === 'string' && typeof vb === 'string') return va.localeCompare(vb, 'pt-BR') * dir;
      return ((va as number) - (vb as number)) * dir;
    });
  }

  private _valorOrdenacaoBusca(p: any, campo: string): string | number | null {
    switch (campo) {
      case 'pn':          return String(p.refforn ?? p.referencia ?? p.codprod ?? '');
      case 'cd':           return String(p.condicao ?? '');
      case 'descricao':    return String(p.descricao ?? '');
      case 'alternativo':  return String(p.alternativo ?? '');
      case 'un':           return String(p.codvol ?? '');
      case 'estoque':      return p.estoque ?? 0;
      case 'valorMoedaIpi': return this.custoMoedaBusca(p, this.cotacaoValorNumerico);
      case 'valorReaisIpi': return this.custoReaisBusca(p);
      case 'vlrIpi':        return this.vlrIpiUnitarioBusca(p, this.cotacaoValorNumerico);
      case 'fabricante':    return String(p.marca ?? '');
      case 'dataUltAtual':  return this._dataBrParaOrdenacao(p.dataUltAtualPreco);
      case 'limiteDias':    return p.limitePrazoAtualDias > 0 ? p.limitePrazoAtualDias : null;
      case 'codigo':        return p.codprod ?? null;
      default:              return null;
    }
  }

  confirmarSelecaoPeca(): void {
    const prod = this.buscaPecasProdutoSelecionado;
    if (!prod || !this._buscaPecasItem) return;
    this._buscaPecasItem.codprod = prod.refforn ?? prod.referencia ?? String(prod.codprod ?? '');
    this._preencherItem(this._buscaPecasItem, prod);
    this.fecharBuscaPecas();
  }

  selecionarPecaModal(prod: any): void {
    if (this._buscaPecasItem) {
      this._buscaPecasItem.codprod = prod.refforn ?? prod.referencia ?? String(prod.codprod ?? '');
      this._preencherItem(this._buscaPecasItem, prod);
    }
    this.fecharBuscaPecas();
  }

  fecharBuscaPecas(): void {
    this.buscaPecasAberta             = false;
    this._buscaPecasItem              = null;
    this.buscaPecasResultados         = [];
    this.buscaPecasTermo              = '';
    this.buscaPecasProdutoSelecionado = null;
    this.buscaPecasLocais             = [];
    this.buscaPecasImagemUrl          = null;
    this.buscaPecasImagensExtras      = [];
    this.buscaPecasImagemIndexAtivo    = 0;
    this.imagemPreviewAberta          = false;
    this.buscaPecasProdutoExpandido       = null;
    this.buscaPecasAlternativos           = [];
    this.buscaPecasAlternativosCarregando = false;
    this.filtrosBusca                     = {};
    this.colunaFiltroAberta               = null;
    this.buscaPecasOrdenarCampo           = null;
    this.buscaPecasOrdemAsc               = true;
  }

  buscaTotalLocais(campo: 'qtdTotal' | 'qtdReservada' | 'disponivel'): number {
    return this.buscaPecasLocais.reduce((acc, l) => acc + ((l[campo] as number) ?? 0), 0);
  }

  corLinhaEstoque(codemp: number): string {
    const cores: Record<string, string> = { '1': '#dbeafe', '2': '#dcfce7', '3': '#fef9c3', '4': '#fce7f3' };
    return cores[String(codemp)] ?? '';
  }

  private _preencherItem(item: ItemCompra, prod: any): void {
    item.descricao        = prod.descricao ?? '';
    item.codprodOriginal  = item.codprod;
    item.unidade          = prod.codvol ?? 'UN';
    item.codprodInterno   = prod.codprod ? Number(prod.codprod) : undefined;
    item.codlocalpadrao   = prod.codlocalpadrao ? Number(prod.codlocalpadrao) : 0;
    this._buscarPrecoItem(item);
    this.onFiltroQtdeVendidaMudou();
  }

  private async _buscarPrecoItem(item: ItemCompra): Promise<void> {
    await this._carregarPrecoEstoqueItem(item);

    // Produto encontrado → foca QTD da linha atual (nova linha só é criada ao dar Enter na QTD)
    // Só faz sentido pro fluxo de 1 item por vez (digitar PN, importar Excel
    // linha a linha) -- import em massa (Funções > Peças com Venda) chama
    // _carregarPrecoEstoqueItem() direto, sem essa parte, pra não ficar
    // fazendo querySelectorAll na tabela inteira centenas/milhares de vezes.
    const idx = this.itens.indexOf(item);
    setTimeout(() => {
      const rows = document.querySelectorAll<HTMLElement>('.pcf-itens-table tbody tr');
      const qtd  = rows[idx]?.querySelector<HTMLInputElement>('.pcf-cell-qtd');
      qtd?.focus(); qtd?.select();
    }, 60);
  }

  /** Núcleo de _buscarPrecoItem() sem a parte de foco/DOM -- busca preço
   *  (PedidoVendaGlobalSP.doBuscarPrecoExc) e dispara a atualização de
   *  estoque pro item. Usado tanto por _buscarPrecoItem() (fluxo de 1 item)
   *  quanto direto pelo import em massa da "Funções > Peças com Venda". */
  /** Trocou a empresa: o local do estoque é por empresa -- recarrega os locais de todos os itens. */
  private _subEmpresaMudou?: Subscription;

  private _recarregarLocaisDosItens(): void {
    if (this.carregandoEdicao) return;
    for (const it of this.itens) {
      if (!it.codprodInterno) continue;
      it.localSel = undefined;
      it.locaisOpcoes = [];
      void this._carregarLocaisItem(it);
    }
  }

  // ── Local do estoque do item (Sankhya TGFEST/TGFLOC) + local do Aerosys (informativo) ──
  /** Sem local com saldo -> Local Coringa (TGFLOC 95000000). */
  private readonly LOCAL_CORINGA = 95000000;

  /**
   * Carrega os locais do produto na empresa. Pré-seleciona o da ENTRADA MAIS RECENTE (a pessoa pode trocar,
   * inclusive escolher "FIFO" = local da entrada mais antiga com saldo). Sem local com saldo: Coringa.
   * Se o usuário já escolheu (ou veio da edição), mantém a escolha.
   */
  private async _carregarLocaisItem(item: ItemCompra): Promise<void> {
    if (!item.codprodInterno) return;
    const codemp = parseInt(this.empresaState.codEmpReal ?? '0', 10) || 0;
    try {
      const res: any = await firstValueFrom(
        this.gateway.buscarLocaisParaItem(item.codprodInterno, codemp, item.localSel).pipe(timeout(12000))
      );
      const body = res?.responseBody ?? res;
      const lista: any[] = body?.locais ?? [];
      item.locaisOpcoes = lista.map(l => ({
        codLocal:   Number(l.codLocal),
        descrLocal: String(l.descrLocal ?? ''),
        estoque:    Number(l.estoque ?? 0),
        dtEntrada:  String(l.dtEntrada ?? ''),
      }));
      const atual = item.localSel;
      if (atual && !item.locaisOpcoes.some(o => o.codLocal === atual)) {
        item.locaisOpcoes.push({ codLocal: atual, descrLocal: 'Local atual', estoque: 0, dtEntrada: '' });
      }
      const valido = !!atual;
      if (!valido) {
        this.aplicarOrdemLocal(item, item.localOrdem ?? 'RECENTE');
      }
    } catch {
      if (item.localSel == null) item.localSel = this.LOCAL_CORINGA;
    }
    // garante que o valor selecionado (ex.: Coringa) sempre exista como opção do seletor
    item.locaisOpcoes = item.locaisOpcoes ?? [];
    if (item.localSel && !item.locaisOpcoes.some(o => o.codLocal === item.localSel)) {
      item.locaisOpcoes.push({ codLocal: item.localSel, descrLocal: item.localSel === this.LOCAL_CORINGA ? 'LOCAL CORINGA' : 'Local atual', estoque: 0, dtEntrada: '' });
    }
    // Local do Aerosys (texto, ex.: 1-A-1) -- só para consulta
    try {
      const est: any = await firstValueFrom(
        this.gateway.buscarEstoqueAerosys(item.codprodInterno, codemp || undefined).pipe(timeout(12000))
      );
      item.localAerosys = String(est?.local ?? '').trim();
    } catch { /* informativo */ }
  }

  /**
   * Consulta FIFO: escolhe, entre os locais com saldo, o da entrada MAIS ANTIGA ('FIFO') ou MAIS RECENTE ('RECENTE').
   * Sem local com saldo -> Coringa. O botão "FIFO" ao lado do seletor alterna entre as duas ordens.
   */
  aplicarOrdemLocal(item: ItemCompra, ordem: 'RECENTE' | 'FIFO'): void {
    item.localOrdem = ordem;
    const c = (item.locaisOpcoes ?? [])
      .filter(o => o.codLocal !== this.LOCAL_CORINGA)
      .sort((a, b) => ordem === 'FIFO'
        ? (a.dtEntrada || '9999').localeCompare(b.dtEntrada || '9999')
        : (b.dtEntrada || '').localeCompare(a.dtEntrada || ''));
    item.localSel = c.length > 0 ? c[0].codLocal : this.LOCAL_CORINGA;
  }

  alternarFifoLocal(item: ItemCompra): void {
    this.aplicarOrdemLocal(item, item.localOrdem === 'FIFO' ? 'RECENTE' : 'FIFO');
  }

  private _codLocalDoItem(item: ItemCompra): number {
    return Number(item.localSel) || Number(item.codlocalpadrao) || this.LOCAL_CORINGA;
  }

  private async _carregarPrecoEstoqueItem(item: ItemCompra): Promise<void> {
    if (!item.codprodInterno) return;
    void this._carregarLocaisItem(item);
    const codemp = parseInt(this.empresaState.codEmpReal ?? '0', 10) || 0;
    try {
      // timeout -- num import em massa de milhares de itens, 1 chamada que
      // nunca responde (nem sucesso nem erro) travava o Promise.all() do
      // lote inteiro pra sempre, e a importação ficava presa em "Importando..."
      // sem nunca terminar. Com timeout, essa chamada falha depois de 12s
      // (cai no catch, item fica sem preço) e a importação segue em frente.
      const res: any = await firstValueFrom(
        this.gateway.buscarPrecoExc(item.codprodInterno, codemp).pipe(timeout(12000))
      );
      const body = res?.responseBody ?? res;
      const info = body?.info ?? body;
      const vlrVenda = parseFloat(String(info?.vlrVenda ?? '0').replace(',', '.')) || 0;
      // Core do catálogo (TGFPRO) — mesmo campo usado no Pedido de Venda.
      const vlrCore = parseFloat(String(info?.vlrCore ?? '0').replace(',', '.')) || 0;
      const core    = String(info?.controlaCore ?? 'N').toUpperCase() === 'S';

      item.vlrCore      = vlrCore;
      item.controlaCore = core;

      const taxa = this.cotacaoValorNumerico;
      const coreUnitBrl = (core && vlrCore > 0 && taxa > 0)
        ? parseFloat((vlrCore * taxa).toFixed(2)) : 0;
      item.coreUnitBrl = coreUnitBrl;

      // Preço unitário SEMPRE com Core embutido quando ativo (igual ao Pedido de Venda)
      const precoUsdFinal = vlrVenda + (core ? vlrCore : 0);
      item.precoUsd    = parseFloat(precoUsdFinal.toFixed(2));
      item.precoUsdStr = item.precoUsd > 0 ? this.fmtDecimal(item.precoUsd) : '';

      if (taxa > 0) {
        item.precoUnitario = parseFloat((item.precoUsd * taxa).toFixed(2));
      }
      this._calcularTotal(item);
      this._atualizarEstoque(item);
    } catch {/* ignora */ }
  }

  /** Enter na QTD → cria próxima linha (se for a última) e foca o PN dela */
  confirmarItemCompra(item: ItemCompra, event: Event): void {
    event.preventDefault();
    const idx    = this.itens.indexOf(item);
    const isLast = idx === this.itens.length - 1;
    if (isLast) {
      this.adicionarLinha();
    }
    setTimeout(() => {
      const rows = document.querySelectorAll<HTMLElement>('.pcf-itens-table tbody tr');
      rows[idx + 1]?.querySelector<HTMLInputElement>('.pcf-cell-pn')?.focus();
    }, 60);
  }

  private async _atualizarEstoque(item: ItemCompra): Promise<void> {
    if (!item.codprodInterno) return;
    const codemp = parseInt(this.empresaState.codEmpReal ?? '0', 10) || 0;
    try {
      const res: any = await firstValueFrom(
        this.gateway.buscarEstoquePorLocal(item.codprodInterno).pipe(timeout(12000))
      );
      const lista: any[] = (res?.responseBody ?? res)?.locais ?? [];
      let total = 0;
      for (const loc of lista) {
        const emp = parseInt(String(loc.codemp ?? '0'), 10);
        if (codemp > 0 && emp !== codemp) continue;
        total += parseFloat(String(loc.disponivel ?? '0').replace(',', '.')) || 0;
      }
      item.estoque = parseFloat(total.toFixed(3));
    } catch {/* ignora */ }
  }

  onPnBlur(item: ItemCompra, event: FocusEvent): void {
    const rel = event.relatedTarget as HTMLElement | null;
    if (rel?.closest?.('.pcf-busca-pecas-modal')) return;
    const pn = (item.codprod ?? '').trim();
    if (!pn) {
      if (item.codprodInterno || item.descricao) {
        item.codprodInterno = undefined;
        item.descricao      = '';
        this.abrirAlerta('PN apagado. Digite o PN e pressione ENTER para buscar.', 'aviso');
      }
      return;
    }
    if (this._pnFoiAlterado(item)) {
      this._limparProdutoParaNovaBusca(item);
    } else if (item.codprodInterno) {
      return;
    }
    this.buscarProdutoPorPN(item, event as unknown as Event);
  }

  // ── Formulário válido ───────────────────────────────────────
  get formularioValido(): boolean {
    return !!this.fornecedorSelecionado && !!this.dataEmissao;
  }

  // ── Salvar ──────────────────────────────────────────────────
  async salvar(): Promise<void> {
    if (this.salvando()) return;                    // guard contra duplo clique
    if (!this.formularioValido) {
      this.abrirAlerta('Preencha o Fornecedor e a Data de Emissão.', 'aviso');
      return;
    }
    if (this.itensValidos.length === 0) {
      this.abrirAlerta('Adicione pelo menos um item com PN válido.', 'aviso');
      return;
    }

    this.salvando.set(true);
    try {
      const payload: any = {
        cabecalho: {
          codEmp:      Number(this.empresaState.codEmpReal ?? 1),
          codParc:     Number(this.fornecedorSelecionado!.codparc),
          codTipOper:  this.COD_TIP_OPER,
          // Parceiro importador (TGFCAB.CODPARCIMP): só nas TOPs de importação (1408), = fornecedor
          codParcImp:  this.tipoGpl !== 'NACIONAL' ? Number(this.fornecedorSelecionado!.codparc) : null,
          codTipVenda: Number(this.tipoNegociacaoSelecionado || 1),
          codCenCus:   Number(this.centroResultadoSelecionado ?? 0),
          codProj:     Number(this.projetoSelecionado ?? 0),
          codNat:      Number(this.naturezaSelecionada ?? 0),
          observacao:  this.observacao ?? '',
          obsInterna:  this.observacaoInterna ?? '',
          adObs:       '',
          adFreteObs:  '',
          numPedido2:  this.numPedido2 ?? '',
          mantemCotacao: 'S',
          tipoNumTitulo: 'COM',
          numTitulo:       this.numTitulo ?? '',
          numPo:           this.numPo ?? '',
          numOrdem:        this.numOrdem ?? '',
          numCotacao:      this.numCotacao ?? '',
          numEntrega:      this.numEntrega ?? '',
          numRastreamento: this.numRastreamento ?? '',
          codVend:     this.compradorSelecionado ? Number(this.compradorSelecionado) : null,
          dataEmissao: this._isoToBr(this.dataEmissao),
          dtPrevent:   this._isoToBr(this.dtPrevent),
          dtNegociacao: this._isoToBr(this.dataEmissao),
          tipFrete:    '',
          codParcTransp: null,
          cifFob:      '',
          formaEnvio:  '',
          qtdVol:      null,
          pesoBruto:   null,
          vlrFrete:    null,
          vlrFreteTtl: null,
          prioridade:  this.prioridadeSelecionada || '',
          despachar:   '',
          fatImediato: '',
          tipoGpl:     this.tipoGpl ?? '',
          adCategoria: this.adCategoria ?? '',
          gplStatus:   'Aberto',
          codAero:     null,
          codParcDest: this.clienteEntregaSelecionado ? Number(this.clienteEntregaSelecionado.codparc) : null,
          vlrMoeda:    this.cotacaoValorNumerico || null,
          vlrDescTot:  null,
          percDesc:    null,
        },
        itens: this.itensValidos.map(i => ({
          codprod:       i.codprodInterno!,
          codvol:        i.unidade || 'UN',
          qtdneg:        i.quantidade || 1,
          vlrunit:       i.precoUnitario || 0,
          percdesc:      Math.abs(i.desconto || 0),
          vlrdesc:       (i.vlrDesc || 0) > 0 ? (i.vlrDesc || 0) : 0,
          vlracrescdesc: (i.vlrDesc || 0) < 0 ? Math.abs(i.vlrDesc || 0) : (i.vlrAcrescDesc || 0),
          codlocal:      this._codLocalDoItem(i),
          vlrtot:        i.total || 0,
          vlrunitmoe:    i.precoUsd || 0,
          vlrtotmoe:     i.totalUsd || 0,
          vlripi:        0,
          vlrsubst:      0,
          // Campos CORE — igual ao Pedido de Venda: AD_COREATIVO gravável, AD_INFORMACORE calculado.
          ad_core:       i.controlaCore ? 'S' : 'N',
          ad_vlrcore:    i.vlrCore || 0,
          pciId:         i.pciId ?? 0,
        })),
      };

      // Empresa virtual (ex.: 12): o Sankhya grava a REAL; a virtual vai em GPL_EMPRESA_VIRTUAL.
      const empSel = Number(this.empresaState.selecionada ?? 0);
      if (empSel && empSel !== Number(payload.cabecalho.codEmp)) {
        payload.cabecalho.empresaVirtual = empSel;
      }

      const isCriacao = !(this.modoEdicao && this.nunotaAtual);

      // Itens vindos de "Importar Pré-Compras": pré-compras do Aerosys (para o Aerosys mover o status)
      // e FATURAMENTO das pré-compras do Sankhya para a TOP da compra (1401/1408).
      const itensOrigem = this.itensValidos.filter(i => i.origemItem);
      if (isCriacao && itensOrigem.length > 0) {
        const idsAe = new Set<number>();
        for (const i of itensOrigem) if (i.pcpId) idsAe.add(i.pcpId);
        for (const id of this._idsPreCompraAerosysSelecionados) idsAe.add(id);
        if (idsAe.size > 0) payload.cabecalho.idsPreCompraAerosys = Array.from(idsAe).join(',');
        const doSankhya = itensOrigem.filter(i => i.origemItem === 'SANKHYA' && i.headerIdOrigem && i.seqOrigem);
        if (doSankhya.length > 0) {
          if (doSankhya.length !== this.itensValidos.length) {
            this.abrirAlerta('Não misture itens de Pré-Compra do Sankhya com itens manuais/Aerosys na mesma compra. Separe em compras distintas.', 'aviso');
            this.salvando.set(false);
            return;
          }
          payload.faturamento = {
            serie: '1',
            itens: doSankhya.map(i => ({
              nunota:    i.headerIdOrigem,
              sequencia: i.seqOrigem,
              qtdFat:    i.quantidade || 1,
              codprod:   i.codprodInterno,
              pciId:     i.pciId ?? 0,
              pcpId:     i.pcpId ?? 0,
            })),
          };
        }
      }
      if (!isCriacao) {
        payload.cabecalho.nunota = this.nunotaAtual;
      }

      // Na CRIAÇÃO de um pedido novo, usa o endpoint dedicado que também tenta
      // espelhar o pedido no Aerosys (best-effort). Na EDIÇÃO, mantém o mesmo
      // caminho de sempre (só Sankhya) -- ver gravarCompra() no service.
      const res: any = isCriacao
        ? await firstValueFrom(this.gateway.gravarCompra(payload))
        : await firstValueFrom(this.gateway.gravarPedidoVenda(payload));

      const sankhyaBody: any = isCriacao
        ? (res?.sankhya?.responseBody ?? res?.sankhya ?? res)
        : (res?.responseBody ?? res);

      if (sankhyaBody?.sucesso === true || sankhyaBody?.sucesso === 'true') {
        const nunota = sankhyaBody?.nunota ?? '';
        let mensagem = `Compra gravada! NUNOTA: ${nunota}`;
        if (isCriacao) {
          const buckets: any[] = res?.aerosysBuckets ?? [];
          if (res?.aerosysOk === false) {
            const erros = buckets.filter(b => b?.ok === false).map(b => `${b?.tipo}: ${b?.erro}`);
            mensagem += erros.length
              ? ` (aviso: não foi possível espelhar no Aerosys — ${erros.join(' | ')})`
              : ' (aviso: não foi possível espelhar esta compra no Aerosys — o Sankhya já está gravado normalmente.)';
          } else if (buckets.length > 1 && buckets.every(b => b?.ok)) {
            mensagem += ` (espelhado no Aerosys em ${buckets.length} compras: ${buckets.map(b => `${b.tipo} #${b.cprId}`).join(', ')})`;
          }
        }
        this.abrirAlerta(mensagem, 'sucesso');
        this._resetar();
        setTimeout(() => this.voltarLista.emit(), 1500);
      } else {
        const erro = sankhyaBody?.erro ?? res?.statusMessage ?? 'Erro desconhecido ao gravar.';
        this.abrirAlerta(erro, 'erro');
      }
    } catch (err: any) {
      const msg = err?.error?.detail ?? err?.error?.statusMessage ?? err?.error?.message ?? err?.message ?? 'Erro ao gravar compra.';
      this.abrirAlerta(msg, 'erro');
    } finally {
      this.salvando.set(false);
    }
  }

  // ── Carregar para edição ────────────────────────────────────
  async carregarParaEdicao(nunota: number): Promise<void> {
    this.carregandoEdicao = true;
    try {
      const res: any = await firstValueFrom(this.gateway.buscarDetalhesPedidoVenda(nunota));
      const body     = res?.responseBody ?? res;
      const d        = body?.sucesso ? (body.detalhe ?? body) : null;
      if (!d) { this.abrirAlerta('Compra não encontrada para edição.', 'erro'); return; }

      if (d.dtmovIso)        this.dataEmissao              = d.dtmovIso;
      if (d.dtpreventIso)    this.dtPrevent                = d.dtpreventIso;
      if (d.codvend != null) this.compradorSelecionado      = d.codvend;
      if (d.codtipvenda)     this.tipoNegociacaoSelecionado = d.codtipvenda;
      if (d.codnat != null)    this.naturezaSelecionada          = d.codnat;
      if (d.codcencus != null) this.centroResultadoSelecionado   = d.codcencus;
      if (d.codproj != null)   this.projetoSelecionado            = d.codproj;
      if (d.observacao != null) this.observacao = d.observacao;
      if (d.obsInterna != null) this.observacaoInterna = d.obsInterna;
      if (d.numPedido2 != null) this.numPedido2 = d.numPedido2;
      if (d.numTitulo != null) this.numTitulo = d.numTitulo;
      if (d.numPo != null) this.numPo = d.numPo;
      if (d.numOrdem != null) this.numOrdem = d.numOrdem;
      if (d.numCotacao != null) this.numCotacao = d.numCotacao;
      if (d.numEntrega != null) this.numEntrega = d.numEntrega;
      if (d.numRastreamento != null) this.numRastreamento = d.numRastreamento;
      if (d.prioridade) this.prioridadeSelecionada = d.prioridade;
      if (d.tipoGpl != null) this.tipoGpl = d.tipoGpl;
      if (d.adCategoria != null) this.adCategoria = d.adCategoria;
      if (d.gplStatus != null) this.gplStatusAtual = d.gplStatus;

      if (d.vlrMoeda && Number(d.vlrMoeda) > 0) {
        const taxa = Number(d.vlrMoeda);
        this.cotacaoTexto      = taxa.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 });
        this.cotacaoSelecionada = { valor: String(taxa), data: '' } as any;
      }

      if (d.codparc && d.cliente) {
        try {
          const resCli: any = await firstValueFrom(
            this.gateway.buscarFornecedorPedidoCompra(String(d.codparc))
          );
          const bodyCli = resCli?.responseBody ?? resCli;
          const lista: FornecedorSugestao[] = bodyCli?.lista ?? [];
          const found = lista.find((c: any) => String(c.codparc) === String(d.codparc));
          const obj: FornecedorSugestao = found ?? { codparc: d.codparc, nomeparc: d.cliente, docparc: d.docparc ?? '' };
          this.fornecedorSelecionado = obj;
          this.fornecedorBusca       = this._montarTextoFornecedor(obj);
          this._recalcularTitulosFornecedor(obj);
        } catch {
          this.fornecedorSelecionado = { codparc: d.codparc, nomeparc: d.cliente };
          this.fornecedorBusca       = this._montarTextoFornecedor(this.fornecedorSelecionado);
          this._recalcularTitulosFornecedor(this.fornecedorSelecionado);
        }
      }

      // Cliente a ser Entregue (codParcDest) -- mesmo campo da "Pessoa de
      // Entrega" do Pedido de Venda, restaurado na edição se preenchido.
      if (d.codParcDest && Number(d.codParcDest) > 0) {
        try {
          const resDest: any = await firstValueFrom(
            this.gateway.buscarClientePedidoVenda(String(d.codParcDest))
          );
          const bodyDest = resDest?.responseBody ?? resDest;
          const listaDest: FornecedorSugestao[] = bodyDest?.lista ?? [];
          const foundDest = listaDest.find((c: any) => String(c.codparc) === String(d.codParcDest));
          if (foundDest) {
            this.clienteEntregaSelecionado = foundDest;
            this.clienteEntregaBusca       = this._montarTextoClienteEntrega(foundDest);
            this._recalcularTitulosClienteEntrega(foundDest);
          }
        } catch { /* mantém vazio se a busca falhar */ }
      }

      if (Array.isArray(d.itens) && d.itens.length > 0) {
        let nextId = 1;
        const taxa = this.cotacaoValorNumerico;
        this.itens = d.itens.map((it: any) => {
          const precoUsd  = Number(it.precoUsd) || Number(it.vlrunitmoe) || 0;
          const vlrunit   = Number(it.vlrunit) || 0;
          const item: ItemCompra = {
            id:             nextId++,
            codprod:        it.refforn ?? it.referencia ?? String(it.codprod ?? ''),
            codprodOriginal: it.refforn ?? it.referencia ?? String(it.codprod ?? ''),
            codprodInterno: Number(it.codprod),
            descricao:      it.descricao ?? '',
            unidade:        it.codvol ?? 'UN',
            quantidade:     Number(it.qtd ?? it.qtdneg) || 1,
            precoUsd:       precoUsd > 0 ? precoUsd : (taxa > 0 && vlrunit > 0 ? parseFloat((vlrunit / taxa).toFixed(2)) : 0),
            precoUsdStr:    '',
            precoUnitario:  vlrunit,
            // Arredondado pra 2 casas só pra exibição (mesmo ajuste do Pedido
            // de Venda) — o vlrDesc exato na linha abaixo continua intacto.
            desconto:       Math.round((Number(it.percdesc) || 0) * 100) / 100,
            vlrDesc:        Number(it.vlrdesc) || 0,
            vlrAcrescDesc:  Number(it.vlracrescdesc) || 0,
            total:          Number(it.vlrtot) || 0,
            totalUsd:       0,
            estoque:        0,
            codlocalpadrao: Number(it.codlocal) || 0,
            localSel:       Number(it.codlocal) > 0 ? Number(it.codlocal) : undefined,
            vlrCore:        Number(it.vlrCore) || 0,
            coreUnitBrl:    0,
            totalCoreBrl:   0,
            controlaCore:   String(it.controlaCore ?? 'N').toUpperCase() === 'S',
          };
          item.precoUsdStr = item.precoUsd > 0 ? this.fmtDecimal(item.precoUsd) : '';
          // vlrunit (TGFITE.VLRUNIT) já foi salvo com o Core embutido — só
          // recalcula coreUnitBrl (usado no toggle e no Total Core informativo),
          // sem somar de novo em precoUsd/precoUnitario (mesmo cuidado do Pedido de Venda,
          // evita valor em dobro ao reabrir um pedido salvo com Core ativo).
          if (item.controlaCore && item.vlrCore > 0) {
            item.coreUnitBrl = taxa > 0 ? parseFloat((item.vlrCore * taxa).toFixed(2)) : 0;
          }
          this._calcularTotal(item);
          this._atualizarEstoque(item);
          return item;
        });
        this._proximoId = nextId + 1;
        this.onFiltroQtdeVendidaMudou();
        for (const it of this.itens) void this._carregarLocaisItem(it);
      }
    } catch (err: any) {
      this.abrirAlerta('Erro ao carregar compra: ' + (err?.message ?? ''), 'erro');
    } finally {
      this.carregandoEdicao = false;
    }
  }

  // ── Inicialização ───────────────────────────────────────────
  constructor(
    private readonly gateway: SankhyaGatewayService,
    readonly empresaState: EmpresaStateService,
    private readonly produtoService: ProdutoService,
  ) {}

  ngOnDestroy(): void {
    this.abaItensChange.emit(false);
    this._subEmpresaMudou?.unsubscribe();
  }

  ngOnInit(): void {
    this._subEmpresaMudou = this.empresaState.empresaMudou.subscribe(() => this._recarregarLocaisDosItens());
    if (this.nunotaEditar != null) {
      this.nunotaAtual = this.nunotaEditar as number;
      this.modoEdicao  = true;
    }

    if (!this.modoEdicao) {
      this.dataEmissao = new Date().toISOString().substring(0, 10);
      this._proximoId  = 1;
      this.itens       = [this._novoItem()];
    }

    this._carregarCompradores();
    this._carregarTiposNegociacao();
    this._carregarNaturezas();
    this._carregarCentrosResultado();
    this._carregarProjetos();
    this._carregarCotacoes();
    this._carregarOpcoesTipoGpl();
    this._carregarOpcoesCategoria();
    this._carregarDescricaoTop();

    this._qtdeVendidaSubject.pipe(debounceTime(600))
      .subscribe(() => this.buscarQtdeVendida());

    if (this.modoEdicao && this.nunotaEditar != null) {
      this.carregarParaEdicao(this.nunotaEditar as number);
    }
  }

  // ── Carga inicial ───────────────────────────────────────────

  /** Troca do TIPO: atualiza a descrição da TOP (1408/1401) exibida. */
  aoMudarTipoGpl(): void {
    this._carregarDescricaoTop();
  }

  /** Nome real da TOP (TGFTOP.DESCROPER) -- ver comentário em COD_TIP_OPER. */
  private async _carregarDescricaoTop(): Promise<void> {
    try {
      const res: any = await firstValueFrom(this.gateway.buscarDescricaoTop(this.COD_TIP_OPER));
      const body = res?.responseBody ?? res;
      if (body?.sucesso && body?.descricao) {
        this.descricaoTop = body.descricao;
      }
    } catch {
      // Mantém o fallback ('Compra') -- não é crítico pra tela funcionar.
    }
  }

  /** Opções de GPL_TIPO (NACIONAL/IMPORTAÇÃO) via
   *  CampoOpcoesComponentSP.doBuscarOpcoes -- mesmo endpoint genérico já
   *  usado na Venda. Em modo criação, prioriza IMPORTAÇÃO como padrão. */
  private async _carregarOpcoesTipoGpl(): Promise<void> {
    try {
      const res: any = await firstValueFrom(this.gateway.buscarOpcoesCampoPedidoVenda('TGFCAB', 'GPL_TIPO'));
      const body      = res?.responseBody ?? res;
      const opcoes: OpcaoCampo[] = (body?.opcoes ?? []).map((o: any) =>
        typeof o === 'string' ? { valor: o, opcao: o } : { valor: o.valor ?? o, opcao: o.opcao ?? o.valor ?? o }
      );

      if (body?.sucesso && Array.isArray(opcoes) && opcoes.length > 0) {
        this.tipoGplOpcoes = opcoes;
        if (!this.modoEdicao) {
          const importacao = opcoes.find(o => o.valor === 'IMPORTACAO');
          this.tipoGpl = importacao ? importacao.valor : (opcoes[0]?.valor ?? 'IMPORTACAO');
        }
      }
    } catch { }
  }

  /** Opções de CATEGORIA (TGFCAB.AD_CATEGORIA) via o mesmo endpoint genérico
   *  já usado na Venda. Em modo criação, prioriza DESPESA como padrão (a
   *  pedido do usuário -- faz mais sentido pra compra do que RECEITA). Em
   *  edição, esse default nunca é aplicado -- o valor vem do banco em
   *  carregarParaEdicao (d.adCategoria). */
  private async _carregarOpcoesCategoria(): Promise<void> {
    try {
      const res: any = await firstValueFrom(this.gateway.buscarOpcoesCampoPedidoVenda('TGFCAB', 'AD_CATEGORIA'));
      const body      = res?.responseBody ?? res;
      const opcoes: OpcaoCampo[] = (body?.opcoes ?? []).map((o: any) =>
        typeof o === 'string' ? { valor: o, opcao: o } : { valor: o.valor ?? o, opcao: o.opcao ?? o.valor ?? o }
      );

      if (body?.sucesso && Array.isArray(opcoes) && opcoes.length > 0) {
        this.adCategoriaOpcoes = opcoes;
        if (!this.modoEdicao) {
          const despesa = opcoes.find(o => o.valor.toUpperCase() === 'DESPESA');
          this.adCategoria = despesa ? despesa.valor : (opcoes[0]?.valor ?? '');
        }
      }
    } catch { }
  }

  /** Rótulo exibido pro combo GPL_TIPO -- não usa o texto (`opcao`) vindo do
   *  banco porque o TDDOPC.OPCAO desse campo está gravado com encoding
   *  quebrado ("IMPORTAÇÃO" virou lixo/mojibake). O `valor` (código, sem
   *  acento) não tem esse problema, então montamos o rótulo localmente. */
  labelTipoGpl(valor: string): string {
    if (valor === 'IMPORTACAO') return 'IMPORTAÇÃO';
    if (valor === 'NACIONAL')   return 'NACIONAL';
    return valor;
  }

  private async _carregarCompradores(): Promise<void> {
    try {
      // Só TIPVEND = 'C' (comprador) -- TGFVEN também tem vendedores (TIPVEND
      // = 'V') e outros tipos, que não fazem sentido aqui na Pré-Compra.
      const res: any = await firstValueFrom(this.gateway.buscarVendedoresPedidoVenda({ tipVend: 'C' }));
      const body     = res?.responseBody ?? res;
      if (body?.sucesso && Array.isArray(body.vendedores)) {
        this.compradores = body.vendedores;
      }
    } catch { }

    if (!this.modoEdicao) {
      let codVendPadrao: string | number | null = null;
      try {
        const res: any = await firstValueFrom(this.gateway.buscarVendedorLogadoPedidoVenda());
        const body     = res?.responseBody ?? res;
        // Só usa o vendedor logado como comprador padrão se ele realmente
        // estiver na lista de compradores (TIPVEND='C') -- senão o campo
        // ficaria com um código selecionado que não aparece nas opções.
        // Retorno do addon: { sucesso, vendedor: { codVend, apelido } } ("0" = sem vendedor).
        const vendLogadoRes = body?.vendedor ?? body ?? {};
        const codVendLogado = Number(vendLogadoRes?.codVend) > 0 ? vendLogadoRes.codVend : null;
        const existeNaLista = codVendLogado != null &&
          this.compradores.some(v => String(v.codVend) === String(codVendLogado));
        if (existeNaLista) { codVendPadrao = codVendLogado; }
      } catch { }

      if (codVendPadrao == null) {
        // Sem vendedor ligado ao usuário: procura na lista de compradores pelo nome do usuário logado.
        const porNome = codVendCompradorDoUsuario(this.compradores);
        if (porNome != null) { codVendPadrao = porNome; }
      }

      if (codVendPadrao == null) {
        // Usuário logado não é comprador (TIPVEND='C') -- cai pro
        // "COMPRADOR" genérico (CODVEND=24), pra facilitar o preenchimento.
        const generico = this.compradores.find(v => String(v.codVend) === '24');
        if (generico) { codVendPadrao = generico.codVend; }
      }

      if (codVendPadrao != null) { this.compradorSelecionado = codVendPadrao; }
    }
  }

  private async _carregarTiposNegociacao(): Promise<void> {
    this.tiposNegociacaoCarregando = true;
    try {
      const res: any = await firstValueFrom(this.gateway.buscarTiposNegociacaoPedidoVenda());
      const body     = res?.responseBody ?? res;
      if (body?.sucesso && Array.isArray(body.tiposVenda)) {
        this.tiposNegociacao = body.tiposVenda
          .filter((t: any) => !!t?.descricao && String(t.descricao).trim().length > 0)
          .sort((a: any, b: any) => String(a.descricao).localeCompare(String(b.descricao)));
      }
    } catch { }
    finally { this.tiposNegociacaoCarregando = false; }
  }

  private async _carregarNaturezas(): Promise<void> {
    this.naturezasCarregando = true;
    try {
      const res: any = await firstValueFrom(this.gateway.buscarNaturezasPedidoVenda());
      const body     = res?.responseBody ?? res;
      const lista    = body?.naturezas ?? [];
      if (body?.sucesso !== false && Array.isArray(lista) && lista.length > 0) {
        const itens = lista
          .filter((n: any) => !!n?.descricao && String(n.descricao).trim().length > 0)
          .sort((a: any, b: any) => String(a.descricao ?? '').localeCompare(String(b.descricao ?? '')));
        const temZero = itens.some((n: any) => String(n.codNat) === '0');
        if (!temZero) itens.unshift({ codNat: '0', descricao: 'Nenhuma' });
        this.naturezas = itens;
      }
    } catch { }
    finally { this.naturezasCarregando = false; }
  }

  private async _carregarCentrosResultado(): Promise<void> {
    this.centrosResultadoCarregando = true;
    try {
      const res: any = await firstValueFrom(this.gateway.buscarCentrosResultadoPedidoVenda());
      const body     = res?.responseBody ?? res;
      const lista    = body?.centros ?? [];
      if (body?.sucesso !== false && Array.isArray(lista) && lista.length > 0) {
        const itens = lista
          .filter((c: any) => !!c?.descricao && String(c.descricao).trim().length > 0)
          .sort((a: any, b: any) => String(a.descricao ?? '').localeCompare(String(b.descricao ?? '')));
        const temZero = itens.some((c: any) => String(c.codCen) === '0');
        if (!temZero) itens.unshift({ codCen: '0', descricao: 'Nenhum' });
        this.centrosResultado = itens;
      }
    } catch { }
    finally { this.centrosResultadoCarregando = false; }
  }

  private async _carregarProjetos(): Promise<void> {
    this.projetosCarregando = true;
    try {
      const res: any = await firstValueFrom(this.gateway.buscarProjetosPedidoVenda());
      const body     = res?.responseBody ?? res;
      const lista    = body?.projetos ?? [];
      if (body?.sucesso !== false && Array.isArray(lista) && lista.length > 0) {
        const itens = lista
          .filter((p: any) => !!p?.descricao && String(p.descricao).trim().length > 0)
          .sort((a: any, b: any) => String(a.descricao ?? '').localeCompare(String(b.descricao ?? '')));
        const temZero = itens.some((p: any) => String(p.codProj) === '0');
        if (!temZero) itens.unshift({ codProj: '0', descricao: 'Nenhum' });
        this.projetos = itens;
      }
    } catch { }
    finally { this.projetosCarregando = false; }
  }

  private async _carregarCotacoes(): Promise<void> {
    this.cotacaoCarregando = true;
    try {
      const res: any = await firstValueFrom(this.gateway.buscarCotacoesDemonstrativo());
      const body     = res?.responseBody ?? res;
      const cotacoes = body?.cotacoes ?? [];
      if (body?.sucesso !== false && Array.isArray(cotacoes)) {
        this.cotacoesDisponiveis = cotacoes;
        if (!this.cotacaoTexto && cotacoes.length > 0) {
          this.cotacaoSelecionada = cotacoes[0];
          this.cotacaoTexto       = this._fmtCotacao(cotacoes[0]);
        }
      }
    } catch { }
    finally { this.cotacaoCarregando = false; }
  }

  // ── Busca de Fornecedor ────────────────────────────────────
  onFornecedorInput(): void {
    if (this.fornecedorSelecionado) {
      this._fornecedorAnterior        = this.fornecedorSelecionado;
      this.fornecedorSelecionado      = null;
      this.fornecedorBusca            = '';
      this.titulosFornecedorPosicionados = [];
    }
    clearTimeout(this._fornecedorTimer);
    const termo = this.fornecedorBusca.trim();
    if (termo.length < 2 && !/^\d+$/.test(termo)) { this.fornecedorSugestoes = []; this.mostrarDropdownFornecedor = false; return; }
    this.mostrarDropdownFornecedor = true;
    this._fornecedorTimer = setTimeout(() => this._buscarFornecedor(termo), 350);
  }

  onFornecedorFocus(): void {
    if (this.fornecedorSelecionado) {
      this._fornecedorAnterior        = this.fornecedorSelecionado;
      this.fornecedorSelecionado      = null;
      this.fornecedorBusca            = '';
      this.fornecedorSugestoes        = [];
      this.titulosFornecedorPosicionados = [];
      this.mostrarDropdownFornecedor  = false;
    }
  }

  onFornecedorBlur(): void {
    setTimeout(() => {
      this.mostrarDropdownFornecedor = false;
      if (!this.fornecedorSelecionado) {
        if (this.fornecedorBusca.trim() && this.fornecedorSugestoes.length > 0) {
          this.selecionarFornecedor(this.fornecedorSugestoes[0]);
        } else if (!this.fornecedorBusca.trim() && this._fornecedorAnterior) {
          this.fornecedorSelecionado = this._fornecedorAnterior;
          this.fornecedorBusca       = this._montarTextoFornecedor(this._fornecedorAnterior);
          this._recalcularTitulosFornecedor(this._fornecedorAnterior);
        }
      }
      this._fornecedorAnterior = null;
    }, 200);
  }

  private async _buscarFornecedor(termo: string): Promise<void> {
    this.fornecedorCarregando = true;
    try {
      const res: any  = await firstValueFrom(this.gateway.buscarFornecedorPedidoCompra(termo));
      const body      = res?.responseBody ?? res;
      this.fornecedorSugestoes = ordenarSugestoesParceiro(body?.lista ?? [], termo);
    } catch { this.fornecedorSugestoes = []; }
    finally { this.fornecedorCarregando = false; }
  }

  selecionarFornecedor(f: FornecedorSugestao): void {
    this._fornecedorAnterior   = null;
    this.fornecedorSelecionado = f;
    this.fornecedorBusca       = this._montarTextoFornecedor(f);
    this.mostrarDropdownFornecedor = false;
    this.fornecedorSugestoes   = [];
    this._recalcularTitulosFornecedor(f);
  }

  removerFornecedor(): void {
    this._fornecedorAnterior        = null;
    this.fornecedorSelecionado      = null;
    this.fornecedorBusca            = '';
    this.fornecedorSugestoes        = [];
    this.titulosFornecedorPosicionados = [];
  }

  // ── Busca de Cliente a ser Entregue (CODPARC destino) ────────
  onClienteEntregaInput(): void {
    if (this.clienteEntregaSelecionado) {
      this._clienteEntregaAnterior          = this.clienteEntregaSelecionado;
      this.clienteEntregaSelecionado        = null;
      this.clienteEntregaBusca              = '';
      this.titulosClienteEntregaPosicionados = [];
    }
    clearTimeout(this._clienteEntregaTimer);
    const termo = this.clienteEntregaBusca.trim();
    if (termo.length < 2 && !/^\d+$/.test(termo)) { this.clienteEntregaSugestoes = []; this.mostrarDropdownClienteEntrega = false; return; }
    this.mostrarDropdownClienteEntrega = true;
    this._clienteEntregaTimer = setTimeout(() => this._buscarClienteEntrega(termo), 350);
  }

  onClienteEntregaFocus(): void {
    if (this.clienteEntregaSelecionado) {
      this._clienteEntregaAnterior           = this.clienteEntregaSelecionado;
      this.clienteEntregaSelecionado         = null;
      this.clienteEntregaBusca               = '';
      this.clienteEntregaSugestoes           = [];
      this.titulosClienteEntregaPosicionados = [];
      this.mostrarDropdownClienteEntrega     = false;
    }
  }

  onClienteEntregaBlur(): void {
    setTimeout(() => {
      this.mostrarDropdownClienteEntrega = false;
      if (!this.clienteEntregaSelecionado) {
        if (this.clienteEntregaBusca.trim() && this.clienteEntregaSugestoes.length > 0) {
          this.selecionarClienteEntrega(this.clienteEntregaSugestoes[0]);
        } else if (!this.clienteEntregaBusca.trim() && this._clienteEntregaAnterior) {
          this.clienteEntregaSelecionado = this._clienteEntregaAnterior;
          this.clienteEntregaBusca       = this._montarTextoClienteEntrega(this._clienteEntregaAnterior);
          this._recalcularTitulosClienteEntrega(this._clienteEntregaAnterior);
        }
      }
      this._clienteEntregaAnterior = null;
    }, 200);
  }

  private async _buscarClienteEntrega(termo: string): Promise<void> {
    this.clienteEntregaCarregando = true;
    try {
      const res: any = await firstValueFrom(this.gateway.buscarClientePedidoVenda(termo));
      const body     = res?.responseBody ?? res;
      this.clienteEntregaSugestoes = ordenarSugestoesParceiro(body?.lista ?? [], termo);
    } catch { this.clienteEntregaSugestoes = []; }
    finally { this.clienteEntregaCarregando = false; }
  }

  selecionarClienteEntrega(c: FornecedorSugestao): void {
    this._clienteEntregaAnterior   = null;
    this.clienteEntregaSelecionado = c;
    this.clienteEntregaBusca       = this._montarTextoClienteEntrega(c);
    this.mostrarDropdownClienteEntrega = false;
    this.clienteEntregaSugestoes   = [];
    this._recalcularTitulosClienteEntrega(c);
  }

  removerClienteEntrega(): void {
    this._clienteEntregaAnterior           = null;
    this.clienteEntregaSelecionado         = null;
    this.clienteEntregaBusca               = '';
    this.clienteEntregaSugestoes           = [];
    this.titulosClienteEntregaPosicionados = [];
  }

  // Busca modal (lupa)
  async abrirModalFornecedor(): Promise<void> {
    this.filtroFornecedorModal    = '';
    this.fornecedorModalLista     = [];
    this.fornecedorModalAberta    = true;
    await this._buscarFornecedorModal('');
  }

  fecharModalFornecedor(): void { this.fornecedorModalAberta = false; }

  onFiltroFornecedorModalChange(): void {
    clearTimeout(this._fornecedorModalTimer);
    this._fornecedorModalTimer = setTimeout(() =>
      this._buscarFornecedorModal(this.filtroFornecedorModal), 350);
  }

  private async _buscarFornecedorModal(termo: string): Promise<void> {
    this.fornecedorModalCarregando = true;
    try {
      const res: any = await firstValueFrom(
        this.gateway.buscarFornecedorPedidoCompra(termo || 'a')
      );
      const body = res?.responseBody ?? res;
      this.fornecedorModalLista = body?.lista ?? [];
    } catch { this.fornecedorModalLista = []; }
    finally { this.fornecedorModalCarregando = false; }
  }

  selecionarFornecedorModal(f: FornecedorSugestao): void {
    this.selecionarFornecedor(f);
    this.fornecedorModalAberta = false;
  }

  // ── Tipo Negociação modal ───────────────────────────────────
  abrirBuscaTipoNegociacao(): void {
    this.filtroTipoNegociacao    = '';
    this.tipoNegociacaoModalAberta = true;
    this._carregarTiposNegociacao();
  }
  fecharBuscaTipoNegociacao(): void { this.tipoNegociacaoModalAberta = false; }
  selecionarTipoNegociacao(t: { codTipVenda: string | number; descricao: string }): void {
    this.tipoNegociacaoSelecionado = t.codTipVenda;
    this.tipoNegociacaoModalAberta = false;
  }
  limparTipoNegociacao(): void { this.tipoNegociacaoSelecionado = ''; }

  // ── Comprador modal ─────────────────────────────────────────
  abrirBuscaComprador(): void { this.filtroComprador = ''; this.compradorModalAberta = true; }
  fecharBuscaComprador(): void { this.compradorModalAberta = false; }
  selecionarComprador(v: VendedorOpcao): void {
    this.compradorSelecionado  = v.codVend;
    this.compradorModalAberta  = false;
  }
  limparComprador(): void { this.compradorSelecionado = null; }

  // ── Helpers ─────────────────────────────────────────────────
  private _montarTextoFornecedor(f: FornecedorSugestao): string {
    const nomeComCodigo = f.codparc ? `${f.codparc} - ${f.nomeparc}` : f.nomeparc;
    const extras: string[] = [];
    if (f.docparc)      extras.push(this.fmtDocumento(f.docparc));
    if (f.inscEstadual) extras.push(this.fmtIE(f.inscEstadual));
    return extras.length > 0 ? `${nomeComCodigo}   |   ${extras.join('   |   ')}` : nomeComCodigo;
  }

  private _recalcularTitulosFornecedor(f: FornecedorSugestao | null): void {
    if (!f) { this.titulosFornecedorPosicionados = []; return; }
    if (!this._fornecCanvasCtx) {
      const canvas = document.createElement('canvas');
      this._fornecCanvasCtx = canvas.getContext('2d');
    }
    const ctx = this._fornecCanvasCtx;
    if (!ctx) { this.titulosFornecedorPosicionados = []; return; }
    ctx.font = this.FORNEC_INPUT_FONT;

    const campos: { label: string; valor?: string; display?: string }[] = [
      { label: 'CNPJ/CPF',      valor: f.docparc,      display: this.fmtDocumento(f.docparc) },
      { label: 'INSC. ESTADUAL', valor: f.inscEstadual,  display: this.fmtIE(f.inscEstadual) },
    ];

    const nomeComCodigo = f.codparc ? `${f.codparc} - ${f.nomeparc}` : f.nomeparc;
    let offset = this.FORNEC_INPUT_TEXT_START_PX + ctx.measureText(nomeComCodigo).width;
    const titulos: { label: string; left: number }[] = [];

    for (const campo of campos) {
      if (!campo.valor || !String(campo.valor).trim()) continue;
      offset += ctx.measureText('   |   ').width;
      titulos.push({ label: campo.label, left: offset });
      offset += ctx.measureText(String(campo.display ?? campo.valor)).width;
    }

    this.titulosFornecedorPosicionados = titulos;
  }

  private _montarTextoClienteEntrega(c: FornecedorSugestao): string {
    const nomeComCodigo = c.codparc ? `${c.codparc} - ${c.nomeparc}` : c.nomeparc;
    const extras: string[] = [];
    if (c.docparc)      extras.push(this.fmtDocumento(c.docparc));
    if (c.inscEstadual) extras.push(this.fmtIE(c.inscEstadual));
    return extras.length > 0 ? `${nomeComCodigo}   |   ${extras.join('   |   ')}` : nomeComCodigo;
  }

  private _recalcularTitulosClienteEntrega(c: FornecedorSugestao | null): void {
    if (!c) { this.titulosClienteEntregaPosicionados = []; return; }
    if (!this._clienteEntregaCanvasCtx) {
      const canvas = document.createElement('canvas');
      this._clienteEntregaCanvasCtx = canvas.getContext('2d');
    }
    const ctx = this._clienteEntregaCanvasCtx;
    if (!ctx) { this.titulosClienteEntregaPosicionados = []; return; }
    ctx.font = this.FORNEC_INPUT_FONT;

    const campos: { label: string; valor?: string; display?: string }[] = [
      { label: 'CNPJ/CPF',       valor: c.docparc,      display: this.fmtDocumento(c.docparc) },
      { label: 'INSC. ESTADUAL', valor: c.inscEstadual, display: this.fmtIE(c.inscEstadual) },
    ];

    const nomeComCodigo = c.codparc ? `${c.codparc} - ${c.nomeparc}` : c.nomeparc;
    let offset = this.FORNEC_INPUT_TEXT_START_PX + ctx.measureText(nomeComCodigo).width;
    const titulos: { label: string; left: number }[] = [];

    for (const campo of campos) {
      if (!campo.valor || !String(campo.valor).trim()) continue;
      offset += ctx.measureText('   |   ').width;
      titulos.push({ label: campo.label, left: offset });
      offset += ctx.measureText(String(campo.display ?? campo.valor)).width;
    }

    this.titulosClienteEntregaPosicionados = titulos;
  }

  fmtDocumento(doc: string | null | undefined): string {
    const d = (doc ?? '').replace(/\D/g, '');
    if (d.length === 14) return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    if (d.length === 11) return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    return doc || '';
  }

  fmtIE(ie: string | null | undefined): string {
    const d = (ie ?? '').replace(/\D/g, '');
    if (d.length === 12) return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{3})$/, '$1.$2.$3.$4');
    if (d.length === 10) return d.replace(/^(\d{3})(\d{5})(\d{2})$/, '$1.$2-$3');
    if (d.length === 9)  return d.replace(/^(\d{3})(\d{3})(\d{3})$/, '$1.$2.$3');
    if (d.length === 8)  return d.replace(/^(\d{2})(\d{3})(\d{2})(\d{1})$/, '$1.$2.$3-$4');
    return ie || '';
  }

  fmtDecimal(n: number): string {
    return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 });
  }

  fmtMoeda(n: number): string {
    return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /** digitsInfo do pipe "number" para qualquer campo de quantidade/estoque com
   *  base na unidade do produto (mesma lógica usada em Pedido de Venda e
   *  Consulta de Peças). UN nunca tem fração (não dá pra comprar "meia
   *  peça"), então mostra inteiro; unidades fracionárias (M, KG, L, etc.)
   *  continuam mostrando até 3 casas decimais. */
  casasDecimaisQtd(unidade: string | null | undefined, valor?: number | string | null): string {
    // "valor" às vezes chega como string (ex.: BigDecimal serializado como "2.000"
    // pelo backend) em vez de number — Number.isInteger('2.000') sempre retorna
    // false para string, mesmo o valor sendo inteiro, então isso derrubava pro
    // fallback por unidade e voltava a mostrar ".000". Convertendo com Number(...)
    // e tolerando resíduo de ponto flutuante (ex.: 1.9999999999998 vindo de SUM()
    // no Oracle) cobre os dois casos.
    if (valor != null && valor !== '') {
      const num = typeof valor === 'string' ? Number(valor.replace(',', '.')) : valor;
      if (Number.isFinite(num) && Math.abs(num - Math.round(num)) < 1e-6) {
        return '1.0-0';
      }
    }
    const un = String(unidade ?? 'UN').trim().toUpperCase();
    return un === 'UN' ? '1.0-0' : '1.0-3';
  }

  /** digitsInfo do painel "Estoque por Local" — usa a unidade do produto
   *  selecionado na busca de peças (F3). */
  casasDecimaisEstoqueLocal(valor?: number | string | null): string {
    return this.casasDecimaisQtd(this.buscaPecasProdutoSelecionado?.codvol, valor);
  }

  // ── Alerta ──────────────────────────────────────────────────
  abrirAlerta(mensagem: string, tipo: 'sucesso' | 'erro' | 'aviso'): void {
    this.alerta = { mensagem, tipo };
    setTimeout(() => this.alerta = null, 5000);
  }

  // ── Reset ───────────────────────────────────────────────────
  /** Converte data de ISO (YYYY-MM-DD) para o formato esperado pelo backend Oracle (DD/MM/YYYY). */
  private _isoToBr(iso: string | null | undefined): string {
    if (!iso) return '';
    const parts = iso.split('-');
    if (parts.length !== 3) return iso;
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }

  private _resetar(): void {
    this._idsPreCompraAerosysSelecionados.clear();
    this._idsPreCompraSankhyaSelecionados.clear();
    this._snapshotIdsPreCompras = null;
    this._numPoAuto = '';
    this._proximoId  = 1;
    this.itens       = [this._novoItem()];
    this.observacao  = '';
    this.observacaoInterna = '';
    this.numPedido2  = '';
    this.numTitulo       = '';
    this.numPo           = '';
    this.numOrdem        = '';
    this.numCotacao      = '';
    this.numEntrega      = '';
    this.numRastreamento = '';
    this.fornecedorSelecionado        = null;
    this.fornecedorBusca              = '';
    this.titulosFornecedorPosicionados = [];
    this.clienteEntregaSelecionado        = null;
    this.clienteEntregaBusca              = '';
    this.titulosClienteEntregaPosicionados = [];
    this.abaAtiva    = 'dados';
    this.modoEdicao  = false;
    this.nunotaAtual = null;
    this.gplStatusAtual = '';
    this.compradorSelecionado = null;
    this.prioridadeSelecionada = 'NORMAL';
    this.tipoGpl = 'IMPORTACAO';
    this.adCategoria = 'DESPESA';
    this.tipoNegociacaoSelecionado  = '1';
    this.naturezaSelecionada        = '3010101';
    this.centroResultadoSelecionado = '201000';
    this.projetoSelecionado         = '1000000000';
    this.dataEmissao = new Date().toISOString().substring(0, 10);
    this.dtPrevent   = '';
  }
}
